<template>
  <div class="ml-6 mr-6 mt-4"><!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-layout row wrap>
      <v-flex sm6 xs12 md6 lg12>
        <v-card height="auto" class="mb-6 rounded-lg" flat>
          <v-card-title height="50" class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
            <v-icon small class="mr-4" color="grey">mdi-laptop</v-icon> Analytical Overview > Most Talked
          </v-card-title>

          <v-alert class="mb-3" v-if="alert" border="top" :color="colorAlert" dark>
            {{ message }}
          </v-alert>
          <!-- TOPIC BERITA DAN PERIODE BERITA -->
          <v-row class="mt-4 ml-2">
            <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                :items="topicsentiment"
                item-text="TOPIC"
                item-value="SEQ_ID"
                v-model="selectedTopic"
                @change="parameter_proses_topic"
                label="Topic"
                outlined
                rounded
              ></v-select>
            </v-col>
            <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                class="elevation-0 shadow-0"
                dense
                dark
                background-color="#0471A5"
                :items="topickeywordsentiment"
                v-model="selectedTopic2"
                label="Keyword"
                @change="parameter_proses_keyword"
                outlined
                rounded
              ></v-select>
            </v-col>
            <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-select
                dense
                class="elevation-0 shadow-0"
                :items="periodeberita"
                v-model="selectedPeriode"
                label="Periode Berita"
                @change="parameter_proses_periode"
                outlined
                rounded
              >
                <template v-slot:append-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-width="200"
                        offset-x
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small width="120" color="#0471A5" v-bind="attrs" v-on="on" dark>
                            Custom
                          </v-btn>
                        </template>
                        <v-card>
                          <!-- update show custom date -->
                          <v-row justify="space-around" class="ma-4">
                            <v-date-picker
                              class="ml-8"
                              v-model="date1"
                              :show-current="false"
                              color="#0471A5"
                              header-color="#0471A5"
                              @change="showCustomDate"
                            ></v-date-picker>
                            <v-date-picker
                              dense
                              v-model="date2"
                              :show-current="false"
                              color="#0471A5"
                              @change="showCustomDate"
                            ></v-date-picker>
                          </v-row>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="menu = false">
                              Cancel
                            </v-btn>
                            <v-btn color="primary" text @click="menu = false, parameter_proses_custom()">
                              Set
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <!-- update show custom date -->
            <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="3">
              <v-card height="37" outlined style="border-radius: 30px;" v-if="showDate1 != '' && showDate2 != '' && selectedPeriode == 'Custom'">
                <v-card-text class="pa-2 px-4">
                  <v-icon>mdi-calendar</v-icon>
                  <span class="mt-2 ml-1">{{ showDate1[1] + " " + showDate1[0] + " " + showDate1[2] }} - {{ showDate2[1] + " " + showDate2[0] + " " + showDate2[2] }}</span>
                </v-card-text>
              </v-card>
            </v-col>
            <!-- Button Filter -->
            <v-col class="d-flex ma-0 pa-0" sm="2">
              <v-btn
                dense
                color="#439EDF"
                dark
                rounded
                @click="parameter_proses_periode(), loadKontenBerita2()"
              >
                <v-icon class="ml-2">mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <!-- End Button Filter -->
            <!--Filter logika-->
            <v-col class="d-flex ma-0 pa-0" sm="2">
              <v-card-text class="d-flex ma-0 pa-0">
                <v-dialog v-model="dialogFilterLogika" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      dense
                      v-bind="attrs"
                      v-on="on"
                      color="#439EDF"
                      dark
                      rounded
                    >
                      Filter
                      <v-icon class="ml-2">mdi-plus</v-icon>
                    </v-btn>
                  </template>

                  <v-card style="overflow-x: hidden">
                    <v-toolbar height="50px" color="#439EDF" dark>
                      Filter logika
                    </v-toolbar>
                    <v-card-text class="pa-6 overflow-card" style="height: 400px; background-color:#F4F7FA;">
                      <v-card flat style="background-color:#F4F7FA;" class="mb-4">
                        <v-row class="ma-0 pa-0 my-3">
                          <v-flex lg4>
                            <v-select
                              :items="itemsFilterLogika"
                              item-text="logic"
                              item-value="logic"
                              v-model="valueFilterLogika"
                              @change="disableLogicFilter"
                              label="Logic Filter"
                              dense
                              outlined
                            ></v-select>
                          </v-flex>
                          <v-flex lg4 class="mx-3">
                            <v-text-field
                              dense
                              outlined
                              v-model="valueKataKunci"
                              v-on:input="updateKataKunci"
                              label="Kata Kunci"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg3 v-if="listObjFilterLogika.length == 0">
                            <v-card-text class="d-flex ma-0 pa-0">
                              <v-btn icon @click="addFilterLogika()">
                                <v-icon color="primary">mdi-plus-circle</v-icon>
                              </v-btn>
                            </v-card-text>
                          </v-flex>
                        </v-row>
                        <v-row v-for="(item, i) in listObjFilterLogika" :key="i" class="ma-0 pa-0 my-3">
                          <v-flex lg4>
                            <v-select
                              :items="itemsSelectFilterLogika[i]"
                              item-text="logic"
                              item-value="logic"
                              v-model="listObjFilterLogika[i].operator"
                              @change="changeSelectFilterLogika(listObjFilterLogika[i].operator, i)"
                              dense
                              outlined
                            ></v-select>
                          </v-flex>
                          <v-flex lg4 class="mx-3">
                            <v-text-field
                              dense
                              outlined
                              v-model="listObjFilterLogika[i].keyword_logic"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg3 v-if="i == listObjFilterLogika.length - 1">
                            <v-card-text class="d-flex ma-0 pa-0">
                              <v-btn icon @click="addFilterLogikaInList(item, i)">
                                <v-icon color="primary">mdi-plus-circle</v-icon>
                              </v-btn>
                              <v-btn icon @click="deleteFilterLogika(i)">
                                <v-icon color="red">mdi-minus-circle</v-icon>
                              </v-btn>
                            </v-card-text>
                          </v-flex>
                        </v-row>
                      </v-card>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="pa-3">
                      <v-spacer></v-spacer>
                      <v-btn text @click="dialogFilterLogika = false, finalObjFilterLogika()">
                        Cancel
                      </v-btn>
                      <v-btn text color="#439EDF" @click="dialogFilterLogika = false, finalObjFilterLogika()">
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card-text>
            </v-col>
            <!--END Filter logika-->
            <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
              <v-btn
                height="35"
                width="100"
                color="#0471A5"
                justify="end"
                class="white--text"
                @click="
                  statusFilter = '',
                  isClickBuble = '',
                  isClickBubleOrg = '',
                  isClickWord = '',
                  resetcolorClicked = true,
                  changeBackgroundColor = '',
                  changeBackgroundColorTweet = '',
                  changeBackgroundColorYt = '',
                  loadTopic(),
                  parameter_proses_periode(),
                  filterReset()
                "
              >
                Reset
              </v-btn>
            </v-col>
          </v-row>
          <!--END TOPIC DAN PERIODE BERITA-->
          <v-row>
            <v-flex lg8>
              <div class="example ml-4 mb-4 mt-6">
                <v-card-text>Sentiment Analysis</v-card-text>
                <apexcharts class="mr-3" width="100%" height="240px" type="line" :options="sentimentanalysis" :series="seriessentiment"></apexcharts>
              </div>
              <div align="center" justify="center">
                <v-row class="mx-4 mb-4" align="center" justify="center">
                  <v-flex xs12 sm12 md12 lg4>
                    <v-btn
                      :style="{ backgroundColor : changeBackgroundColor ? '#e1f2fa !important' : '#fff' }"
                      color="#fff"
                      x-large
                      width="220px"
                      height="80"
                      class="mx-3 my-3"
                      style="color: #0471A5; border-radius: 8px; box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;"
                      @click="changeBackgroundColor = !changeBackgroundColor, changeBackgroundColorTweet = false, changeBackgroundColorYt = false, loadSentimentanalysisBerita()"
                    >
                      <v-card-text>
                        <h2 align="center" justify="center" class="text--teal darken-2">
                          <v-avatar class="color-avatar4" size="36">
                            <v-icon class="white--text">mdi-web</v-icon>
                          </v-avatar>
                          {{ valueTotalBerita }}
                        </h2>
                        <h5 align="center" justify="center" class="text--teal darken-2">Total Berita Online</h5>
                      </v-card-text>
                    </v-btn>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg4>
                    <v-btn
                      :style="{ backgroundColor : changeBackgroundColorTweet ? '#e1f2fa !important' : '#fff' }"
                      color="#fff"
                      x-large
                      width="220px"
                      height="80"
                      class="mx-3 my-3"
                      style="color: #0471A5; border-radius: 8px; box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;"
                      @click="changeBackgroundColorTweet = !changeBackgroundColorTweet, changeBackgroundColor = false, changeBackgroundColorYt = false, loadSentimentTweet()"
                    >
                      <v-card-text>
                        <h2 align="center" justify="center" class="text--teal darken-2">
                          <v-avatar class="color-avatar3" size="36">
                            <v-icon class="white--text">mdi-twitter</v-icon>
                          </v-avatar>
                          {{ valueTotalTwet }}
                        </h2>
                        <h5 align="center" justify="center" class="text--teal darken-2">Total Tweet</h5>
                      </v-card-text>
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg4>
                    <v-btn
                      :style="{ backgroundColor : changeBackgroundColorYt ? '#e1f2fa !important' : '#fff' }"
                      color="#fff"
                      x-large
                      width="220px"
                      height="80"
                      class="mx-3 my-3"
                      style="color: #0471A5; border-radius: 8px; box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;"
                      @click="changeBackgroundColorYt = !changeBackgroundColorYt, changeBackgroundColor = false, changeBackgroundColorTweet = false, loadSentimentYt()"
                    >
                      <v-card-text>
                        <h2 align="center" justify="center" class="text--teal darken-2 my-2">
                          <v-avatar class="color-avatar2" size="36">
                            <v-icon class="white--text">mdi-youtube</v-icon>
                          </v-avatar>
                          {{ valueTotalYt }}
                        </h2>
                        <h5 align="center" justify="center" class="text--teal darken-2 my-2">Total Comment Youtube</h5>
                      </v-card-text>
                    </v-btn>
                  </v-flex>
                </v-row>
              </div>
            </v-flex>

            <v-flex lg4>
              <v-card flat max-width="400px" height="auto">
                <v-card-text class="mt-4">
                  <apexchart type="donut" :options="chartOptions" :series="seriess" @dataPointSelection="filterBySentiment"></apexchart>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>

      <v-flex sm6 xs12 md6 lg6>
        <v-card height="610px" class="mt-4 mr-4 mb-6 rounded-lg" flat>
          <v-card-text class="text-md-body-1">Influencing</v-card-text>
          <v-container fill-height fluid>
            <v-row align="center" justify="center">
              <!-- update filter buble                       -->
              <v-col>
                <Toppersonbubble
                  ref="topPersonComponent"
                  :resetcolorClicked="resetcolorClicked"
                  :selectedTopic2="selectedTopic2"
                  :selectedTopic="selectedTopic"
                  :selectedPeriode="selectedPeriode"
                  :statusFilter="statusFilter"
                  :isClickBubleOrg="isClickBubleOrg"
                  :isClickWord="isClickWord"
                  :updateSocket="updateSocket"
                  @clicked="filterByBuble"
                ></Toppersonbubble>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex sm6 xs12 md6 lg6>
        <v-card height="300px" width="100%" class="mt-4 mr-4 mb-6 rounded-lg justify-center align-center" flat>
          <v-card-text class="text-md-body-1">Influenced Topics</v-card-text>
          <div width="100%" class="mr-16 align-center justify-center" align="center" justify="center">
            <!-- <vue-word-cloud class="ml-10" width="100%" align="center" justify="center"
              style="height: 200px;"
              :words="words"
              :color="([, weight]) => weight > 10 ? '#0471A5' : weight > 5 ? '#0471A5' : '#0471A5'"
              font-family="Roboto"
              @clicked="filterByWord"
            /> -->
            <vue-word-cloud :words="words" class="ml-10" width="100%" align="center" :spacing="0.55" style="height: 200px;" :color="([, weight]) => weight > 10 ? '#0471A5' : weight > 5 ? '#0471A5' : '#0471A5'" font-family="Roboto">
              <template slot-scope="{text, weight, word}">
                <div :title="weight" style="cursor: pointer;" @click="isClickWord = word.text, loadKontenBerita2(word.text)">
                  {{ text }}
                </div>
              </template>
            </vue-word-cloud>
          </div>
        </v-card>
        <v-card height="300px" class="mt-4 mb-6 rounded-lg" flat>
          <v-row class="ma-0 pa-0">
            <v-card-text class="ml-4" v-if="isPerson == true">
              <v-btn class="mt-2 mb-4 elevation-0" small rounded color="#0471A5" dark @click="isPerson = true, isOrganisasi = false, loadKontenBerita2()">
                Person
              </v-btn>
              <v-btn class="mt-2 mb-4 elevation-0 ml-2" small rounded outlined color="#0471A5" dark @click="isOrganisasi = true, isPerson = false, loadKontenBerita2()">
                Organization
              </v-btn>
            </v-card-text>
            <v-card-text class="ml-4" v-if="isOrganisasi == true">
              <v-btn class="mt-2 mb-4 elevation-0" small rounded outlined color="#0471A5" dark @click="isPerson = true, isOrganisasi = false, loadKontenBerita2()">
                Person
              </v-btn>
              <v-btn class="mt-2 mb-4 elevation-0 ml-2" small rounded color="#0471A5" dark @click="isOrganisasi = true, isPerson = false, loadKontenBerita2()">
                Organization
              </v-btn>
            </v-card-text>
          </v-row>
          <apexchart type="bar" height="200" :options="barchart" :series="series1" @click="clickChartBar"></apexchart>
        </v-card>
      </v-flex>

      <v-flex sm12 xs12 md12 lg12>
        <v-card height="600px" class="mt-4 mr-4 mb-6 rounded-lg" flat>
          <v-flex lg12>
            <v-row class="pa-4">
              <v-flex lg8 md8>
                <v-card-text class="text-md-body-1">
                  Konten Berita
                </v-card-text>
              </v-flex>
              <v-flex lg4 md4>
                <v-card-text class="d-flex align-end flex-column">
                  <div>
                    <v-btn small class="mr-4" outlined color="#0471A5">
                      Capture
                    </v-btn>
                    <!-- --- full  -->
                    <v-btn icon class="ml-2" @click="dialogKontenBerita = true">
                      <v-icon color="primary">mdi-scan-helper</v-icon>
                    </v-btn>

                    <v-dialog
                      v-model="dialogKontenBerita"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                      scrollable
                    >
                      <v-card tile>
                        <v-toolbar flat dark color="primary">
                          <v-btn icon dark @click="dialogKontenBerita = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <v-toolbar-title>Konten Berita</v-toolbar-title>
                        </v-toolbar>

                        <v-card-text>
                          <v-list>
                          <!-- <v-card height="1135px" class="elevation-0 overflow-card"> -->
                            <v-row class="ma-2">
                            <!--card-->
                              <v-flex lg12 v-for="item in kontenBerita" :key="item.id">
                                <v-hover v-slot="{ hover }" close-delay="200">
                                  <v-card :href="item.url" target="_blank" flat class="mb-2 rounded-lg" :elevation="hover ? 8 : 0" :class="{ 'on-hover': hover }">
                                    <v-list-item three-line class="pt-2">
                                      <v-list-item-content>
                                        <v-flex lg8>
                                          <v-list-item-title class="body-1 mb-1 primary--text">
                                            {{ item.title }}
                                          </v-list-item-title>
                                        </v-flex>
                                        <v-list-item-subtitle>
                                          {{ item.content }}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-card>
                                </v-hover>
                              </v-flex>
                              <!--end card-->
                            </v-row>
                            <!-- </v-card> -->
                            <div class="text-center">
                              <v-pagination
                                class="mt-6 my-2"
                                v-model="page"
                                :length="pagelength"
                                prev-icon="mdi-menu-left"
                                next-icon="mdi-menu-right"
                                @input="handlePageChange"
                              ></v-pagination>
                            </div>
                          </v-list>
                        </v-card-text>
                        <div style="flex: 1 1 auto;"></div>
                      </v-card>
                    </v-dialog>
                    <!-- --- end full  -->
                  </div>
                </v-card-text>
              </v-flex>
            </v-row>
            <v-row class="ma-4">
              <v-flex xs12 sm12 md12 lg12>
                <v-tabs color="#0471A5" class="mr-4">
                  <v-tab class="tab">
                    Netral <v-chip small class="ma-2" color="#0471A5" text-color="white">{{ beritaNetralPersen }} %</v-chip>
                  </v-tab>
                  <v-tab-item>
                    <v-card width="100%" height="450px" class="overflow-card" flat>
                      <v-row class="mx-2 my-4">
                        <!--card-->
                        <v-flex xs12 sm12 md12 lg12 v-for="item in kontenBeritaNetral" :key="item.id">
                          <v-hover v-slot="{ hover }" close-delay="200">
                            <v-card :href="item.url" target="_blank" flat class="mb-4 rounded-lg" :elevation="hover ? 8 : 0" :class="{ 'on-hover': hover }">
                              <div class="d-flex flex-no-wrap justify-space-between">
                                <div>
                                  <v-list-item three-line class="pt-4">
                                    <v-list-item-content>
                                      <v-flex lg10>
                                        <v-list-item-title class="body-1 mb-1 primary--text" :href="item.url" target="_blank">
                                          {{ item.title }}
                                        </v-list-item-title>
                                      </v-flex>
                                      <v-list-item-subtitle>
                                        {{ item.url }}
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle>
                                        {{ item.content }}
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </div>
                              </div>
                            </v-card>
                          </v-hover>
                        </v-flex>
                        <!--end card-->
                      </v-row>
                    </v-card>
                  </v-tab-item>

                  <v-tab class="tab">
                    Negatif <v-chip small class="ma-2" color="#0471A5" text-color="white">{{ beritaNegativePersen }} %</v-chip>
                  </v-tab>
                  <v-tab-item>
                    <v-card width="100%" height="450px" class="overflow-card" flat>
                      <v-row class="mx-2 my-4">
                        <!--card-->
                        <v-flex xs12 sm12 md12 lg12 v-for="item in kontenBeritaNegative" :key="item.id">
                          <v-hover v-slot="{ hover }" close-delay="200">
                            <v-card :href="item.url" target="_blank" flat class="mb-2 rounded-lg" :elevation="hover ? 8 : 0" :class="{ 'on-hover': hover }">
                              <div class="d-flex flex-no-wrap justify-space-between">
                                <div>
                                  <v-list-item three-line class="pt-4">
                                    <v-list-item-content>
                                      <v-flex lg10>
                                        <v-list-item-title class="body-1 mb-1 primary--text" :href="item.url" target="_blank">
                                          {{ item.title }}
                                        </v-list-item-title>
                                      </v-flex>
                                      <v-list-item-subtitle>
                                        {{ item.url }}
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle>
                                        {{ item.content }}
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </div>
                              </div>
                            </v-card>
                          </v-hover>
                        </v-flex>
                        <!--end card-->
                      </v-row>
                    </v-card>
                  </v-tab-item>

                  <v-tab class="tab">
                    Positif <v-chip small class="ma-2" color="#1A8EC5" text-color="white">{{ beritaPositifPersen }} %</v-chip>
                  </v-tab>
                  <v-tab-item>
                    <v-card width="100%" height="450px" class="overflow-card" flat>
                      <v-row class="mx-2 my-4">
                        <!--card-->
                        <v-flex xs12 sm12 md12 lg12 v-for="item in kontenBeritaPositive" :key="item.id">
                          <v-hover v-slot="{ hover }" close-delay="200">
                            <v-card :href="item.url" target="_blank" flat class="mb-2 rounded-lg" :elevation="hover ? 8 : 0" :class="{ 'on-hover': hover }">
                              <div class="d-flex flex-no-wrap justify-space-between">
                                <div>
                                  <v-list-item three-line class="pt-4">
                                    <v-list-item-content>
                                      <v-flex lg10>
                                        <v-list-item-title class="body-1 mb-1 primary--text" :href="item.url" target="_blank">
                                          {{ item.title }}
                                        </v-list-item-title>
                                      </v-flex>
                                      <v-list-item-subtitle>
                                        {{ item.url }}
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle>
                                        {{ item.content }}
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </div>
                              </div>
                            </v-card>
                          </v-hover>
                        </v-flex>
                        <!--end card-->
                      </v-row>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-flex>
            </v-row>

            <v-row class="pa-4">
              <v-flex lg2 md2></v-flex>
              <v-flex lg8 md8>
                <v-card-text class="text-md-body-1">
                  <v-pagination
                    class="mt-6 my-2"
                    v-model="page"
                    :length="pagelength"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                    @input="handlePageChange"
                  ></v-pagination>
                </v-card-text>
              </v-flex>
              <v-flex lg2 md2></v-flex>
            </v-row>
          </v-flex>
        </v-card>
      </v-flex>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center">Loading content, please wait</v-card-text>
          <v-card-title class="align-center justify-center">
            <v-progress-circular :size="70" :width="7" color="#0471A5" indeterminate></v-progress-circular>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#0471A5" text @click="dialog = false">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { hierarchy, pack } from 'd3-hierarchy';
import VueApexCharts from 'vue-apexcharts';
import VueWordCloud from 'vuewordcloud';
import Toppersonbubble from '@/components/Toppersonbubble';
import Notification from '@/components/Notification';
import axios from "axios";
import io from 'socket.io-client';

export default {
  components: {
    Toppersonbubble: Toppersonbubble,
    apexcharts: VueApexCharts,
    [VueWordCloud.name]: VueWordCloud,
    Notification: Notification
  },
  data: function() {
    return {
      valueKataKunci: "",
      finalObjectFilterLogika: [],
      objFilterLogika: [],
      listObjFilterLogika: [],
      listFilterLogika: [],
      listFilterLogikaLogic: [],
      valueFilterLogika: "Logic Filter",
      itemsFilterLogika: [
        {
          logic: "Logic Filter",
          disabled: false,
        },
        {
          logic: "Or",
          disabled: false,
        },
        {
          logic: "And",
          disabled: false,
        },
        {
          logic: "Not",
          disabled: false,
        },
      ],
      itemsSelectFilterLogika: [],
      selectedLogika: "Or",
      dialogFilterLogika: false,
      changeBackgroundColor: false,
      changeBackgroundColorTweet: false,
      changeBackgroundColorYt: false,
      socket: io("http://172.20.4.11:2525"),
      updateSocket: "",
      showDate1: "",
      showDate2: "",
      isClickBuble: "",
      isClickWord: "",
      dialogKontenBerita: false,
      Settanggal: [],
      StartDateLast30: "",
      EndDate: "",
      SetPerson: [],
      SetOrganisasi: [],
      chart_data_sort: [],
      chart_data_sortOrganisasi: [],
      words: [],
      SetWord: [],
      selectedTopic: "",
      selectedTopic2: "",
      resetcolorClicked: false,
      colorClicked: "",
      selectedPeriode: "Last 7 Days",
      topicsentiment: [],
      topickeywordsentiment: [],

      periodeberita: ['Today', 'Yesterday', 'Last 7 Days', 'Previous Week', 'Last 30 Days', 'Previous Month'],
      dialog: false,
      isPerson: true,
      isOrganisasi: false,
      click: "",

      beritaNetralPersen : "",
      beritaNegativePersen: "",
      beritaPositifPersen: "",
      kontenBerita: [],
      statusFilter: "",
      isClickBubleOrg: "",

      alert: false,
      colorAlert: "",
      message: "",

      mediaBeritaNew: [],// new
      MediatwitterShareNew: [],// new
      MediaYtShareNew: [],// new
      chartTweet: [],// new
      chartNews: [],// new
      chartCombinasi: [],// new
      valueTotalBerita : "",// new
      valueTotalTwet: "",// new
      valueTotalYt: "",// new

      wordCloudIndx0: [],
      wordCloudIndx1: [],
      wordCloudIndx2: [],
      wordCloudIndx3: [],
      wordCloudIndx4: [],

      // klik button jumlah
      kontenBeritaPositive: [],//all kontent per sentiment
      kontenBeritaNegative: [],//all kontent per sentiment
      kontenBeritaNetral: [],//all kontent per sentiment

      mediaBerita: [],
      MediatwitterShare: [],
      MediaYtShare: [],
      mediaBeritaPositive: [],
      mediaBeritaNegative: [],
      mediaBeritaNetral: [],
      count_chart_mediaBeritaPositive: "",
      count_chart_mediaBeritaNegative: "",
      count_chart_mediaBeritaNetral: "",
      kontenTwitterPositive: [],
      kontenTwitterNegative: [],
      kontenTwitterNetral: [],
      count_chart_kontenTwitterPositive: "",
      count_chart_kontenTwitterNegative: "",
      count_chart_kontenTwitterNetral: "",
      kontenYoutubePositive: [],
      kontenYoutubeNegative: [],
      kontenYoutubeNetral: [],
      count_chart_kontenYoutubePositive: "",
      count_chart_kontenYoutubeNegative: "",
      count_chart_kontenYoutubeNetral: "",

      menu: false,
      date1: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      // date2: '2013-07-29',
      date2: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10),

      // date2: '2013-07-29',
      // =========================================================== pagination variable
      pagetotalcontent: "",
      pageplay: 100,
      pagestart: 0,
      pagelength: "",
      // =========================================================== end page
      /*Chart sentiment analysis*/
      sentimentanalysis: {
        chart: {
          id: 'Memory Usage'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          // width: 2,
        },
        colors: ['#6F6F6F', '#FFB000', '#814AD6', '#fff'], /*color line*/
        xaxis: {
          type: "date",
          tickAmount: 12 // rentant categories
        },
      },
      seriessentiment: [
        {
          name: 'Berita Online',
          data: []
        },
        {
          name: 'Twitter',
          data: []
        },
        {
          name: 'Youtube',
          data: []
        },
        {
          name: '',
          data: []
        },
      ],

      /*Chart buble*/
      chart: [
        {
          name: '',
          amount: 0,
          color: '#F88FB3',
        },
        {
          name: '',
          amount: 0,
          color: '#F1E987'
        },
        {
          name: '',
          amount: 0,
          color: '#B3B8F4'
        },
        {
          name: '',
          amount: 0,
          color: '#5EC3C2',
        },
        {
          name: '',
          amount: 0,
          color: '#AFDAF5'
        },
        {
          name: '',
          amount: 0,
          color: '#C4C4C4'
        },
      ],
      /*end Chart buble*/

      /*pie*/
      seriess: [],
      chartOptions: {
        colors: ['#008FFB', '#FF4560', '#00E396'],
        chart: {
          width: 380,
          type: 'pie',
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                },
              }
            }
          }
        },
        labels: ['Netral', 'Negative', 'Positive'],
      },

      /*radial*/
      seriesonline: [],
      onlinenew: {
        colors: ['#38BABC', '#16A5A7', '#079092', '#057577', '#025354'],
        chart: {
          height: '50px',
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: '22px',
              },
              value: {
                fontSize: '16px',
              },
              total: {
                show: true,
                label: 'Total',
              }
            }
          }
        },
        labels: ['series-1', 'series-2', 'series-3', 'series-4'],
      },

      /*bar chart*/
      series1: [
        {
          data: []
        }
      ],
      barchart: {
        colors: ['#38BABC', '#16A5A7', '#079092'],
        chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            columnWidth: '45%',
            distributed: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px'
            }
          }
        }
      },
    }
  },

  /*Bubblechart*/
  computed: {
    transformedChartData() {
      return {
        name: 'Top Level',
        children: this.chart.map(chart => ({
          ...chart,
          size: chart.amount,
          parent: 'Top Level'
        }))
      }
    },
    layoutData() {
      // Generate a D3 hierarchy
      const rootHierarchy = hierarchy(this.transformedChartData)
        .sum(d => d.size)
        .sort((a, b) => {
          return b.value - a.value
        })
      // Pack the circles inside the viewbox
      return pack()
        .size([500, 500])
        .padding(10)(rootHierarchy)
    },

  /*methods chartbubble*/
  },
  mounted(){
    this.loadTopic()
    this.getRealTimeData()
    // this.loadKontenBerita()
    // this.loadSentimentanalysisInisialisasi()
  },
  methods: {
    finalObjFilterLogika(){
      let objFilterLogikaIndex0 = []
      if(this.valueFilterLogika == "Logic Filter"){
        this.objFilterLogika[0].operator = ""
      }
      objFilterLogikaIndex0.push(this.objFilterLogika[0])
      this.finalObjectFilterLogika = objFilterLogikaIndex0.concat(this.listObjFilterLogika)
      this.$store.commit("addButtonTmp", {
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
      });
    },
    updateKataKunci(){
      this.objFilterLogika[0].keyword_logic = this.valueKataKunci
    },
    disableLogicFilter(){
      for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
        this.itemsSelectFilterLogika[i][0].disabled = false
        this.itemsSelectFilterLogika[i][1].disabled = false
        this.itemsSelectFilterLogika[i][2].disabled = false
      }
      this.itemsFilterLogika[0].disabled = true
      for (let i = 0; i < this.listObjFilterLogika.length; i++) {
        this.listObjFilterLogika[i].operator = this.valueFilterLogika
      }
      if(this.valueFilterLogika == "Or"){
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true
        }
      }
      if(this.valueFilterLogika == "Not"){
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][0].disabled = true
          this.itemsSelectFilterLogika[i][1].disabled = true
        }
      }
      this.objFilterLogika[0].operator = this.valueFilterLogika
    },
    changeSelectFilterLogika(logic, index){
      for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
        this.itemsSelectFilterLogika[i][0].disabled = false
        this.itemsSelectFilterLogika[i][1].disabled = false
        this.itemsSelectFilterLogika[i][2].disabled = false
      }
      if(this.listObjFilterLogika[0].operator == "And"){
        let operatorAnd = []
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          operatorAnd.push(this.listObjFilterLogika[i].operator)
        }
        if (operatorAnd.includes("Or")) {
          let indexOr = operatorAnd.indexOf("Or");
          for (let i = indexOr + 1; i < this.itemsSelectFilterLogika.length; i++) {
            this.itemsSelectFilterLogika[i][1].disabled = true
            this.itemsSelectFilterLogika[0][1].disabled = false
          }
        } else {
          console.log("String does not exist in the array");
        }
      }
      if(logic == "Or" && this.listObjFilterLogika[0].operator == "Or"){
        for (let i = 0 + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic
          this.itemsSelectFilterLogika[i][1].disabled = true
        }
      }
      if(logic == "Not" && this.listObjFilterLogika[0].operator == "Or"){
        for (let i = 0 + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true
          this.itemsSelectFilterLogika[0][1].disabled = false
        }
      }
      if(logic == "Not" && this.valueFilterLogika == "Or"){
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true
        }
      }
      // if(logic == "Not" && this.valueFilterLogika == "And"){
      //   for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
      //     this.itemsSelectFilterLogika[i][1].disabled = true
      //     this.itemsSelectFilterLogika[0][1].disabled = false
      //   }
      // }
      if(logic == "Or" && this.valueFilterLogika == "Or"){
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true
        }
      }
      if(logic == "And"){
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic
        }
      }
      if(logic == "Or"){
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic
          this.itemsSelectFilterLogika[i][1].disabled = true
        }
      }
      if(logic == "Not"){
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic
          this.itemsSelectFilterLogika[i][0].disabled = true
          this.itemsSelectFilterLogika[i][1].disabled = true
          // this.itemsSelectFilterLogika[i][2].disabled = true
        }
      }
    },
    addFilterLogika(){
      let objFilterLogika = {
        operator: this.selectedLogika,
        keyword_logic: this.valueKataKunci
      };
      let listObjFilterLogika = {
        operator: this.selectedLogika,
        keyword_logic: ""
      };
      let listSelectFilterLogika = [
        {
          logic: "Or",
          disabled: false,
        },
        {
          logic: "And",
          disabled: false,
        },
        {
          logic: "Not",
          disabled: false,
        }
      ];
      this.objFilterLogika.push(objFilterLogika)
      this.listObjFilterLogika.push(listObjFilterLogika)
      this.itemsSelectFilterLogika.push(listSelectFilterLogika)
      this.listFilterLogika.push(this.valueKataKunci)
      this.listFilterLogikaLogic.push(this.selectedLogika)
    },
    addFilterLogikaInList(logic, index){
      if(logic.operator == "Not" && this.listObjFilterLogika[0].operator == "Or"){
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true
          this.itemsSelectFilterLogika[0][1].disabled = false
        }
      }
      if(this.listObjFilterLogika[0].operator == "Or" || this.listObjFilterLogika[0].operator == "And"){
        this.selectedLogika = "Or"
      }
      if(this.listObjFilterLogika[0].operator == "Not"){
        this.selectedLogika = "Not"
      }
      let objFilterLogika = {
        operator: logic.operator,
        keyword_logic: logic.keyword_logic
      };
      let listObjFilterLogika = {
        operator: this.selectedLogika,
        keyword_logic: ""
      };
      let listSelectFilterLogika = [
        {
          logic: "Or",
          disabled: false,
        },
        {
          logic: "And",
          disabled: false,
        },
        {
          logic: "Not",
          disabled: false,
        }
      ];
      this.objFilterLogika.push(objFilterLogika)
      this.listObjFilterLogika.push(listObjFilterLogika)
      this.itemsSelectFilterLogika.push(listSelectFilterLogika)
      this.listFilterLogika.push(this.valueKataKunci)
      this.listFilterLogikaLogic.push(this.selectedLogika)
      if(logic.operator == "Or"){
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true
        }
      }
      if(logic.operator == "Not"){
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = "Not"
          this.itemsSelectFilterLogika[i][0].disabled = true
          this.itemsSelectFilterLogika[i][1].disabled = true
          // this.itemsSelectFilterLogika[i][2].disabled = true
        }
      }
    },
    deleteFilterLogika(i){
      let listFilterLogika = this.listFilterLogika
      listFilterLogika.splice(i, 1)
      this.objFilterLogika.splice(i, 1)
      this.listObjFilterLogika.splice(i, 1)
      this.itemsSelectFilterLogika.splice(i, 1)
      let listFilterLogikaAfterDelete = this.listFilterLogika
      this.listFilterLogika = listFilterLogikaAfterDelete
    },
    getRealTimeData(){
      this.socket.on("listUpdate", fetchedData => {
        // Remove non-printable and other non-valid JSON characters
        var s = fetchedData.replace(/\\n/g, "\\n")
                  .replace(/\\'/g, "\\'")
                  .replace(/\\"/g, '\\"')
                  .replace(/\\&/g, "\\&")
                  .replace(/\\r/g, "\\r")
                  .replace(/\\t/g, "\\t")
                  .replace(/\\b/g, "\\b")
                  .replace(/\\f/g, "\\f");
        var dataUpdate = JSON.parse(s);
        console.log(dataUpdate)
        this.kontenBerita = []
        this.kontenBeritaNetral = []
        this.kontenBeritaNegative = []
        this.kontenBeritaPositive = []
        this.kontenBerita = dataUpdate
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Netral") {
            this.kontenBeritaNetral.push(dataUpdate[i]);
          }
        }
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Negative") {
            this.kontenBeritaNegative.push(dataUpdate[i]);
          }
        }
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Positive") {
            this.kontenBeritaPositive.push(dataUpdate[i]);
          }
        }
        this.loadKontenBerita()
        this.updateSocket = true
      })
    },
    // update show custom date
    showCustomDate() {
      var date = new Date(this.date1);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDate1 = dateString;

      var date3 = new Date(this.date2);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDate2 = dateString2;
    },
    // update filter by buble & filter sentiment
    filterByBuble(value) {
      // alert(value);
      this.resetcolorClicked = false
      this.isClickBuble = value;
      this.$store.commit("addButtonTmp", {
        sentiment_glob: this.$store.sentiment_glob,
        ner_person_glob: value,
        ner_organization_glob: this.$store.ner_organization_glob,
      });
      this.loadKontenBerita2();
    },
    filterBySentiment(event, chartContext, config) {
      console.log(config.dataPointIndex)
      this.statusFilter = config.dataPointIndex;
      if (this.statusFilter == 0) {
        this.statusFilter = "Netral";
      }
      if (this.statusFilter == 1) {
        this.statusFilter = "Negative";
      }
      if (this.statusFilter == 2) {
        this.statusFilter = "Positive";
      }
      this.$store.commit("addButtonTmp", {
        sentiment_glob: this.statusFilter,
        ner_person_glob: this.$store.ner_person_glob,
        ner_organization_glob: this.$store.ner_organization_glob,
      });
      this.loadKontenBerita2();
    },
    filterReset() {
      this.$store.commit("addButtonTmp", {
        sentiment_glob: "",
        ner_person_glob: "",
        ner_organization_glob: "",
      });
      this.loadKontenBerita2();
    },
    onWordClick(data){
      const nameWord = this.isClickWord
      data.data = data.data.filter(function (el) {
        if (el.domain != null) { //tambahan karna data ada yang null
          return el.domain.replace('.com','') == nameWord;
        }
      });
      const jumlahBerita = []
      const jumlahTwit = []
      const jumlahYoutube = []
      for (let i = 0; i < data.data.length; i++) {
        if(data.data[i].source == "berita"){
          jumlahBerita.push(data.data[i])
        }
      }
      for (let i = 0; i < data.data.length; i++) {
        if(data.data[i].source == "twitter"){
          jumlahTwit.push(data.data[i])
        }
      }
      for (let i = 0; i < data.data.length; i++) {
        if(data.data[i].source == "youtube"){
          jumlahYoutube.push(data.data[i])
        }
      }
      this.valueTotalBerita = jumlahBerita.length
      this.valueTotalTwet = jumlahTwit.length
      this.valueTotalYt = jumlahYoutube.length

      const beritaNetral = []
      const beritaNegative = []
      const beritaPositive = []
      for (let i = 0; i < data.data.length; i++) {
        if(data.data[i].sentiment == "Netral"){
          beritaNetral.push(data.data[i])
        }
      }
      for (let i = 0; i < data.data.length; i++) {
        if(data.data[i].sentiment == "Negative"){
          beritaNegative.push(data.data[i])
        }
      }
      for (let i = 0; i < data.data.length; i++) {
        if(data.data[i].sentiment == "Positive"){
          beritaPositive.push(data.data[i])
        }
      }
      this.seriess = []
      this.seriess.push(beritaNetral.length, beritaNegative.length, beritaPositive.length)

      this.$refs.topPersonComponent.loadKontenBerita();

      // insialisasi word cloud
      const word = []
      let domain = '';
      data.data.forEach((element) => {
        const get_domain = element["domain"].split(".");
        if(get_domain.length == 2){
          domain = get_domain[0];
        } else if(get_domain.length == 3){
          domain = get_domain[1];
        } else {
          domain = element["domain"];
        }
        word.push(domain);
      });
      const SetttWord = []
      for (let i = 0; i < word.length; i++) {
        SetttWord.push(word[i])
      }
      this.SetWord = [...new Set(SetttWord)]
      this.wordCloudIndx0 = []
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].domain.replace('.com','') == this.SetWord[0]) {
          this.wordCloudIndx0.push(data.data[i])
        }
      }
      this.wordCloudIndx1 = []
      this.wordCloudIndx2 = []
      this.wordCloudIndx3 = []
      this.wordCloudIndx4 = []
      this.words[0] = {"text" : this.SetWord[0], "weight" : this.wordCloudIndx0.length}
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].domain.replace('.com','') == this.SetWord[1]) {
          this.wordCloudIndx1.push(data.data[i])
        }
      }
      this.words[1] = {"text" : this.SetWord[1], "weight" : this.wordCloudIndx1.length}
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].domain.replace('.com','') == this.SetWord[2]) {
          this.wordCloudIndx2.push(data.data[i])
        }
      }
      this.words[2] = {"text" : this.SetWord[2], "weight" : this.wordCloudIndx2.length}
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].domain.replace('.com','') == this.SetWord[3]) {
          this.wordCloudIndx3.push(data.data[i])
        }
      }
      this.words[3] = {"text" : this.SetWord[3], "weight" : this.wordCloudIndx3.length}
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].domain.replace('.com','') == this.SetWord[4]) {
          this.wordCloudIndx4.push(data.data[i])
        }
      }
      this.words[4] = {"text" : this.SetWord[4], "weight" : this.wordCloudIndx4.length}
      // end word cloud

      // inisialisasi person
      if(this.isPerson == true){
        const person = []
        const person2 = []
        data.data.forEach((element) => {
          if(element["ner_person"] != ''  && element["ner_person"] != null){
            person.push(element["ner_person"]);
            person2.push(element["ner_person"]);
          }
        });
        const SetttPerson = []
        const SetttPerson2 = []
        for (let i = 0; i < person.length; i++) {
          SetttPerson.push(person[i].at(-0))
          SetttPerson2.push(person2[i].at(-1))
        }

        const Setperson = [...new Set(SetttPerson)]
        const Setperson2 = [...new Set(SetttPerson2)]
        const Setperson3 = Setperson.concat(Setperson2)

        this.SetPerson = [...new Set(Setperson3)]

        this.chart_data_sort = []
        for (let x = 0; x < this.SetPerson.length; x++) {
          var jum1 = 0;
          for (let i = 0; i < data.data.length; i++) {
            if (data.data[i].ner_person != null) { //tambahan karna data ada yang null
              if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){ //tambahan karna data ada yang null
                if (data.data[i].ner_person[0] == this.SetPerson[x]) {
                  jum1++;
                }
              }
              if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){ //tambahan karna data ada yang null
                if (data.data[i].ner_person[1] == this.SetPerson[x]) {
                  jum1++;
                }
              }
            }
          }

          this.chart_data_sort.push({
            'name_person' : this.SetPerson[x],
            'name_person_value' : jum1
          })
        }
        this.chart_data_sort.sort(function(a,b){ // sort desc value
          return (b.name_person_value) - (a.name_person_value);
        });
        for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
          this.barchart.xaxis.categories[i] = ""
        }
        for (let i = 0; i < this.series1[0].data.length; i++) {
          this.series1[0].data[i] = ""
        }
        for (let x = 0; x < this.chart_data_sort.length; x++) {
          if(x < 6){
            this.series1[0].data[x] = this.chart_data_sort[x].name_person_value
            this.barchart.xaxis.categories[x] = this.chart_data_sort[x].name_person
          }
        }
        for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
          if(this.barchart.xaxis.categories[i] == undefined){
            this.barchart.xaxis.categories[i] = ""
          }
        }
      }

      if(this.isOrganisasi == true){
        const organisasi = []
        const organisasi2 = []
        data.data.forEach((element) => {
          if(element["ner_organization"] != ''  && element["ner_organization"] != null){
            organisasi.push(element["ner_organization"]);
            organisasi2.push(element["ner_organization"]);
          }
        });
        const SetttOrganization = []
        const SetttOrganization2 = []
        for (let i = 0; i < organisasi.length; i++) {
          SetttOrganization.push(organisasi[i].at(-0))
          SetttOrganization2.push(organisasi2[i].at(-1))
        }

        const Setorganization = [...new Set(SetttOrganization)]
        const Setorganization2 = [...new Set(SetttOrganization2)]
        const Setorganization3 = Setorganization.concat(Setorganization2)

        this.SetOrganization = [...new Set(Setorganization3)]

        this.chart_data_sortOrganisasi = []
        for (let x = 0; x < this.SetOrganization.length; x++) {
          var jum1org = 0;
          for (let i = 0; i < data.data.length; i++) {
            if (data.data[i].ner_organization != null) { //tambahan karna data ada yang null
              if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){ //tambahan karna data ada yang null
                if (data.data[i].ner_organization[0] == this.SetOrganization[x]) {
                  jum1org++;
                }
              }
              if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){ //tambahan karna data ada yang null
                if (data.data[i].ner_organization[1] == this.SetOrganization[x]) {
                  jum1org++;
                }
              }
            }
          }

          this.chart_data_sortOrganisasi.push({
            'name_organisasi' : this.SetOrganization[x],
            'name_organisasi_value' : jum1org
          })
        }
        this.chart_data_sortOrganisasi.sort(function(a,b){ // sort desc value
          return (b.name_organisasi_value) - (a.name_organisasi_value);
        });
        for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
          this.barchart.xaxis.categories[i] = ""
        }
        for (let i = 0; i < this.series1[0].data.length; i++) {
          this.series1[0].data[i] = ""
        }
        for (let x = 0; x < this.chart_data_sortOrganisasi.length; x++) {
          if(x < 6){
            this.series1[0].data[x] = this.chart_data_sortOrganisasi[x].name_organisasi_value
            this.barchart.xaxis.categories[x] = this.chart_data_sortOrganisasi[x].name_organisasi
          }
        }
        for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
          if(this.barchart.xaxis.categories[i] == undefined){
            this.barchart.xaxis.categories[i] = ""
          }
        }
      }

      this.kontenBerita = data.data

      const beritaNetralPersen = beritaNetral.length / this.kontenBerita.length * 100
      this.beritaNetralPersen = parseInt(beritaNetralPersen.toFixed(2))
      const beritaNegativePersen = beritaNegative.length / this.kontenBerita.length * 100
      this.beritaNegativePersen = parseInt(beritaNegativePersen.toFixed(2))
      const beritaPositvePersen = beritaPositive.length / this.kontenBerita.length * 100
      this.beritaPositifPersen = parseInt(beritaPositvePersen.toFixed(2))

      this.kontenBeritaNetral = beritaNetral
      this.kontenBeritaNegative = beritaNegative
      this.kontenBeritaPositive = beritaPositive

      this.pagelength = Math.ceil(this.kontenBerita.length / 100)

      // --- new sentiment chart
      this.seriessentiment[0].data = []
      this.seriessentiment[1].data = []
      this.seriessentiment[2].data = []
      var serisnews = []
      for (let i = 0; i < this.Settanggal.length; i++) {
        for (let x = 0; x < data.data.length; x++) {
          if(data.data[x].source == 'berita'){
            if (data.data[x].dateid == this.Settanggal[i]) {
              serisnews.push(data.data[x])
            }
          }
        }
        if(this.Settanggal.length > 1){
          this.seriessentiment[0].data.push({x:this.Settanggal[i],y:serisnews.length})
          serisnews = []
        }
        if(this.Settanggal.length == 1){
          this.seriessentiment[0].data.push({x:this.Settanggal[0],y:serisnews.length},{x:"",y:0})
        }
      }

      var serismedol = []
      for (let i = 0; i < this.Settanggal.length; i++) {
        for (let x = 0; x < data.data.length; x++) {
          if(data.data[x].source == 'twitter'){
            if (data.data[x].dateid == this.Settanggal[i]) {
              serismedol.push(data.data[x]);
            }
          }
        }
        if(this.Settanggal.length > 1){
          this.seriessentiment[1].data.push({x:this.Settanggal[i],y:serismedol.length})
          serismedol = []
        }
        if(this.Settanggal.length == 1){
          this.seriessentiment[1].data.push({x:this.Settanggal[0],y:serismedol.length},{x:"",y:0})
        }
      }

      var seriesytb = []
      for (let i = 0; i < this.Settanggal.length; i++) {
        for (let x = 0; x < data.data.length; x++) {
          if(data.data[x].source == 'youtube'){
            if (data.data[x].dateid == this.Settanggal[i]) {
              seriesytb.push(data.data[x]);
            }
          }
        }
        if(this.Settanggal.length > 1){
          this.seriessentiment[2].data.push({x:this.Settanggal[i],y:seriesytb.length})
          seriesytb = []
        }
        if(this.Settanggal.length == 1){
          this.seriessentiment[2].data.push({x:this.Settanggal[0],y:seriesytb.length},{x:"",y:0})
        }
      }
      window.dispatchEvent(new Event('resize'))
    },
    // end update filter by buble & filter sentiment
    async loadTopic() {
      this.loading = true
      axios.get("keyword_select",
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        this.posts = response.data;
        const data = response.data;
        // alert(data.length);
        for (let i = 0; i < data.length; i++) {
          //sincron data topic sentiment
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob == undefined) {
              this.selectedTopic = data[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicsentiment.push(data[i]);
        }
        this.$store.commit("addTopicKeyword", {
          //send parameter store
          topickeywordsentiment_glob: data,
        });
        this.topickeywordsentiment = [];
        let all = "All";
        for (let i = 0; i < data.length; i++) {
          //sincron data topic sentiment
          if (data[i].SEQ_ID == this.selectedTopic) {
            this.topickeywordsentiment.push(all);
            for (let x = 0; x < data[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                  // this.selectedTopic2 = (data[i].KEYWORD[x].KEYWORD);
                  this.selectedTopic2 = all;
                } else {
                  this.selectedTopic2 = this.$store.topic_glob2;
                }
              }
              // alert(data[i].KEYWORD[x].KEYWORD);
              this.topickeywordsentiment.push(data[i].KEYWORD[x].KEYWORD);
            }
          }
        }

        // topickeywordsentiment
        var date_start = this.date1;
        var date_end = this.date2;
        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          const date_awal = new Date();
          const date = new Date();
          date.setDate(date.getDate() + 0);
          const datenow = date.toISOString().substr(0, 10);
          if (this.selectedPeriode == "Today") {
            this.click = "Today";
            date_start = datenow;
            date_end = datenow;
          }
          if (this.selectedPeriode == "Yesterday") {
            this.click = "Yesterday";
            date_awal.setDate(date_awal.getDate() - 1);
            const date_c = date_awal.toISOString().substr(0, 10);
            date_start = date_c;
            date_end = date_c;
          }
          if (this.selectedPeriode == "Last 7 Days" || this.selectedPeriode == "Previous Week") {
            this.click = "Last 7 Days";
            date_awal.setDate(date_awal.getDate() - 7);
            const date_c = date_awal.toISOString().substr(0, 10);
            date_start = date_c;
            date_end = datenow;
          }
          if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
            this.click = "Last 30 Days";
            date_awal.setDate(date_awal.getDate() - 30);
            const date_c = date_awal.toISOString().substr(0, 10);
            date_start = date_c;
            date_end = datenow;
          }
        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob == undefined) {
          // send parameter store
          // alert('aaa');
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedTopic2,
            selectedPeriode_glob: this.selectedPeriode,
            finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
            date_start_glob: date_start,
            date_end_glob: date_end,
          });
        } else {
          this.selectedTopic2 = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.date1 = this.$store.date_start_glob;
          this.date2 = this.$store.date_end_glob;
        }

        // console.log(this.$store.date_start_glob)
        if (data.length > 0) {
          this.loadKontenBerita2()
        }
        if (this.selectedPeriode == "Custom") {
          this.showCustomDate();
        }
      })
      .catch((e) => {
        this.errors = e.response.data.msg;
        switch (e.response.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log("some other error"); // end up here all the time
            break;
        }
      });
    },

    async parameter_proses_topic() {
      var date_start = this.date1;
      var date_end = this.date2;

      this.topickeywordsentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        //sincron data topic sentiment
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topickeywordsentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              // this.selectedTopic2 = (this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                this.selectedTopic2 = all;
              } else {
                this.selectedTopic2 = this.$store.topic_glob2;
              }
            }
            // alert(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD +' - '+ x);
            this.topickeywordsentiment.push(
              this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD
            );
          }
        }
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      // this.loadKontenBerita2()
    },
    async parameter_proses_keyword() {
      var date_start = this.date1;
      var date_end = this.date2;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      this.parameter_proses_periode();
    },
    async parameter_proses_periode() {
      var date_start = this.date1;
      var date_end = this.date2;
      const date_awal = new Date();
      const date = new Date();
      date.setDate(date.getDate() + 0);
      const datenow = date.toISOString().substr(0, 10);
      if (this.selectedPeriode == "Today") {
        this.click = "Today";
        date_start = datenow;
        date_end = datenow;
      }
      if (this.selectedPeriode == "Yesterday") {
        this.click = "Yesterday";
        date_awal.setDate(date_awal.getDate() - 1);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = date_c;
      }
      if (this.selectedPeriode == "Last 7 Days" || this.selectedPeriode == "Previous Week") {
        this.click = "Last 7 Days";
        date_awal.setDate(date_awal.getDate() - 7);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = datenow;
      }
      if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
        this.click = "Last 30 Days";
        date_awal.setDate(date_awal.getDate() - 30);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = datenow;
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      // this.loadKontenBerita2()
    },
    async parameter_proses_custom() {
      this.selectedPeriode = "Custom";

      // alert(this.selectedPeriode);
      var date_start = this.date1;
      var date_end = this.date2;

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
      });
      // this.loadKontenBerita2()
    },

    async loadKontenBerita2() {
      this.dialog = true;

      let sentiment_search = this.$store.sentiment_glob;
      if (this.$store.sentiment_glob == "" || this.$store.sentiment_glob == undefined) {
        sentiment_search = "";
      }
      let ner_person_search = this.$store.ner_person_glob;
      if (this.$store.ner_person_glob == "" || this.$store.ner_person_glob == undefined) {
        ner_person_search = "";
      }
      let ner_organization_search = this.$store.ner_organization_glob;
      if (this.$store.ner_organization_glob == "" || this.$store.ner_organization_glob == undefined) {
        ner_organization_search = "";
      }
      let object_filter_logika = this.$store.finalobjectfilterlogika_glob;
      if (this.$store.finalobjectfilterlogika_glob == "" || this.$store.finalobjectfilterlogika_glob == undefined) {
        object_filter_logika = "";
      }
      try {
        const data1 = await axios
          .get("solr-new?start_date=" + this.$store.date_start_glob + "&end_date=" + this.$store.date_end_glob + "&topic=" + this.$store.topic_glob + "&topic2=" + this.$store.topic_glob2 + "&sentiment=" + sentiment_search + "&ner_person=" + ner_person_search + "&ner_organization=" + ner_organization_search + "&logic=" + JSON.stringify(object_filter_logika) + "&start=0&rows=" + this.pageplay)
        console.log(data1.data, 'loadKontenBerita2')
        const data = data1.data;
        this.kontenBerita = []
        this.kontenBerita = data.data
        this.kontenBeritaNetral = []
        this.kontenBeritaNegative = []
        this.kontenBeritaPositive = []
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Netral") {
            this.kontenBeritaNetral.push(data.data[i]);
          }
        }
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Negative") {
            this.kontenBeritaNegative.push(data.data[i]);
          }
        }
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Positive") {
            this.kontenBeritaPositive.push(data.data[i]);
          }
        }
        this.loadKontenBerita()

        if (this.isClickWord != '' && data.data.length > 0) {
          this.onWordClick(data)
        }

        // this.socket.emit('sendUpdateList', {kontenBeritaNetral: this.kontenBeritaNetral})
        if (data.data.length > 0) {
          // this.loadSentimentanalysis(data);
          // this.loadKontenOnlineNews(data);
          // this.loadKontenOnlineMedia(data);
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 4000);
          this.message = "Data Not Found";
          this.colorAlert = "red";
        }
        setTimeout(() => {
          this.dialog = false;
        }, 3000);
      } catch(e) {
        console.log(e)
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 3000);
        this.message = "Data Not Found";
        this.colorAlert = "red";
        this.dialog = false;
        // this.loading = false
      }
    },

    async loadKontenBerita(){
      // console.log(this.$store.topic_glob);
      // this.dialog = true;
      let sentiment_search = this.$store.sentiment_glob
      if (this.$store.sentiment_glob == '' || this.$store.sentiment_glob == undefined) {
        sentiment_search = ""
      }
      let ner_person_search = this.$store.ner_person_glob
      if (this.$store.ner_person_glob == '' || this.$store.ner_person_glob == undefined) {
        ner_person_search = ""
      }
      let ner_organization_search = this.$store.ner_organization_glob
      if (this.$store.ner_organization_glob == '' || this.$store.ner_organization_glob == undefined) {
        ner_organization_search = ""
      }
      let object_filter_logika = this.$store.finalobjectfilterlogika_glob
      if (this.$store.finalobjectfilterlogika_glob == "" || this.$store.finalobjectfilterlogika_glob == undefined) {
        object_filter_logika = ""
      }
      try {
        const data1 = await axios.get("solr-dashboard?start_date=" + this.$store.date_start_glob + "&end_date=" + this.$store.date_end_glob + "&startpage=0&pageShow=" + this.pageplay + "&city=&topic2=" + this.$store.topic_glob2 + "&topic=" + this.$store.topic_glob + "&sentiment="+ sentiment_search + "&ner_person=" + ner_person_search + "&ner_organization=" + ner_organization_search + "&logic=" + JSON.stringify(object_filter_logika),
          { headers: { 'auth-token': localStorage.getItem('token_app') } }
        )
        const data = data1.data;
        this.$refs.topPersonComponent.loadKontenBerita();

        // pie edol dan mednewa
        // this.onlinenew.labels = []
        this.seriesonline = []
        this.seriesmedia = []
        this.valueTotalBerita = []
        this.valueTotalTwet = []
        this.valueTotalYt = []

        this.chartTweet = []
        if (data.chart.chart_twit != undefined) {
          this.chartTweet = data.chart.chart_twit //new
        }
        this.chartNews = []
        if (data.chart.chart_news != undefined) {
          this.chartNews = data.chart.chart_news //new
        }
        // this.chartNews = data.chart.chart_news //new
        this.chartCombinasi = [] //new

        this.page = 1
        this.pagelength = data.leghpage //new
        this.pagetotalcontent = data.total_content //new

        this.seriess = []
        // inisialisasi topik
        // inisialisasi tanggal
        const tanggal = []
        this.chartTweet.forEach((element) => {
          tanggal.push(element["date"]);
        });
        this.chartNews.forEach((element) => {
          tanggal.push(element["date"]);
        });
        tanggal.sort(function(a, b) {
          return new Date(a) - new Date(b);
        });

        const Settanggal = [...new Set(tanggal)]

        this.Settanggal = Settanggal;
        // tanggal last 30
        this.EndDate = this.Settanggal.at(-1)
        var time = new Date(this.EndDate);
        time.setDate(time.getDate()-29);
        // this.StartDateLast30 = time.toISOString().substr(0, 10);

        // inisialisasi content per sentiment twet, ytb dan berita
        this.mediaBerita = []
        this.mediaBeritaNetral = []
        this.mediaBeritaNegative = []
        this.mediaBeritaPositive = []
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].source == 'berita') {
            this.mediaBerita.push(data.data[i]);
            if (data.data[i].sentiment == 'Positive') {
              this.mediaBeritaPositive.push(data.data[i]);
            }
            if (data.data[i].sentiment == 'Negative') {
              this.mediaBeritaNegative.push(data.data[i]);
            }
            if (data.data[i].sentiment == 'Netral') {
              this.mediaBeritaNetral.push(data.data[i]);
            }
          }
        }
        this.valueTotalBerita = this.mediaBerita.length

        this.MediatwitterShare = []
        this.kontenTwitterNetral = []
        this.kontenTwitterNegative = []
        this.kontenTwitterPositive = []
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].source == 'twitter') {
            this.MediatwitterShare.push(data.data[i]);
            if (data.data[i].sentiment == 'Negative') {
              this.kontenTwitterNegative.push(data.data[i]);
            }
            if (data.data[i].sentiment == 'Positive') {
              this.kontenTwitterPositive.push(data.data[i]);
            }
            if (data.data[i].sentiment == 'Netral') {
              this.kontenTwitterNetral.push(data.data[i]);
            }
          }
        }
        // this.valueTotalTwet = this.MediatwitterShare.length

        this.MediaYtShare = []
        this.kontenYoutubePositive = []
        this.kontenYoutubeNegative = []
        this.kontenYoutubeNetral = []
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].source == 'youtube') {
            this.MediaYtShare.push(data.data[i]);
            // konten ytb
            if (data.data[i].sentiment == 'Positive') {
              this.kontenYoutubePositive.push(data.data[i]);
            }
            if (data.data[i].sentiment == 'Negative') {
              this.kontenYoutubeNegative.push(data.data[i]);
            }
            if (data.data[i].sentiment == 'Netral') {
              this.kontenYoutubeNetral.push(data.data[i]);
            }
            // end konten ytb
          }
        }
        this.valueTotalYt = this.MediaYtShare.length
        // end inisialisasi content per sentiment

        // inisialisasi button jumlah per no page
        var cout_berita = 0;
        var cout_berita_positif = 0;
        var cout_berita_negativ = 0;
        var cout_berita_netral = 0;
        this.mediaBeritaNew = []
        for (let i = 0; i < this.chartNews.length; i++) {
          this.chartCombinasi.push(this.chartNews[i]);
          this.mediaBeritaNew.push(this.chartNews[i]);
          if (this.chartNews[i].Positive != undefined) {
            cout_berita += this.chartNews[i].Positive;
            cout_berita_positif += this.chartNews[i].Positive;
          }
          if (this.chartNews[i].Negative != undefined) {
            cout_berita += this.chartNews[i].Negative;
            cout_berita_negativ += this.chartNews[i].Negative;
          }
          if (this.chartNews[i].Netral != undefined) {
            cout_berita += this.chartNews[i].Netral;
            cout_berita_netral += this.chartNews[i].Netral;
          }
        }
        this.count_chart_mediaBeritaPositive=(cout_berita_positif);
        this.count_chart_mediaBeritaNegative=(cout_berita_negativ);
        this.count_chart_mediaBeritaNetral=(cout_berita_netral);

        var cout_tweet = 0;
        var cout_tweet_positif = 0;
        var cout_tweet_negativ = 0;
        var cout_tweet_netral = 0;
        this.MediatwitterShareNew = []
        for (let i = 0; i < this.chartTweet.length; i++) {
          this.chartCombinasi.push(this.chartTweet[i]);
          this.MediatwitterShareNew.push(this.chartTweet[i]);
          // cout_tweet += this.chartTweet[i].Total;
          if (this.chartTweet[i].Positive != undefined) {
            cout_tweet += this.chartTweet[i].Positive;
            cout_tweet_positif += this.chartTweet[i].Positive;
          }
          if (this.chartTweet[i].Negative != undefined) {
            cout_tweet += this.chartTweet[i].Negative;
            cout_tweet_negativ += this.chartTweet[i].Negative;
          }
          if (this.chartTweet[i].Netral != undefined) {
            cout_tweet += this.chartTweet[i].Netral;
            cout_tweet_netral += this.chartTweet[i].Netral;
          }
        }
        this.count_chart_kontenTwitterPositive = cout_tweet_positif
        this.count_chart_kontenTwitterNegative = cout_tweet_negativ
        this.count_chart_kontenTwitterNetral = cout_tweet_netral

        var cout_youtube = 0;
        var cout_youtube_positif = 0;
        var cout_youtube_negativ = 0;
        var cout_youtube_netral = 0;
        this.MediaYtShareNew = []
        for (let i = 0; i < this.chartCombinasi.length; i++) {
          if (this.chartCombinasi[i].nameChart == 'youtube') {
            this.MediaYtShareNew.push(this.chartCombinasi[i]);
            // cout_youtube += this.chartCombinasi[i].Total;
            if (this.chartCombinasi[i].Positive != undefined) {
              cout_youtube += this.chartCombinasi[i].Positive;
              cout_youtube_positif += this.chartCombinasi[i].Positive;
            }
            if (this.chartCombinasi[i].Negative != undefined) {
              cout_youtube += this.chartCombinasi[i].Negative;
              cout_youtube_negativ += this.chartCombinasi[i].Negative;
            }
            if (this.chartCombinasi[i].Netral != undefined) {
              cout_youtube += this.chartCombinasi[i].Netral;
              cout_youtube_netral += this.chartCombinasi[i].Netral;
            }
          }
        }

        this.count_chart_kontenYoutubePositive = cout_youtube_positif
        this.count_chart_kontenYoutubeNegative = cout_youtube_negativ
        this.count_chart_kontenYoutubeNetral = cout_youtube_netral

        this.valueTotalBerita = cout_berita
        this.valueTotalTwet = cout_tweet;
        this.valueTotalYt = cout_youtube;

        var sentimen_categori_psitif = 0;
        var sentimen_categori_negative = 0;
        var sentimen_categori_netral = 0;
        var total_all = 0;
        for (let i = 0; i < this.chartCombinasi.length; i++) {
          if (this.chartCombinasi[i].Positive != undefined) {
            total_all += this.chartCombinasi[i].Positive;
            sentimen_categori_psitif += this.chartCombinasi[i].Positive;
          }
          if (this.chartCombinasi[i].Negative != undefined) {
            sentimen_categori_negative += this.chartCombinasi[i].Negative;
            total_all += this.chartCombinasi[i].Negative;
          }
          if (this.chartCombinasi[i].Netral != undefined) {
            sentimen_categori_netral += this.chartCombinasi[i].Netral;
            total_all += this.chartCombinasi[i].Netral;
          }
        }

        const beritaNetralPersen = sentimen_categori_netral / total_all * 100
        this.beritaNetralPersen = parseInt(beritaNetralPersen.toFixed(2))
        const beritaNegativePersen = sentimen_categori_negative / total_all * 100
        this.beritaNegativePersen = parseInt(beritaNegativePersen.toFixed(2))
        const beritaPositvePersen = sentimen_categori_psitif / total_all * 100
        this.beritaPositifPersen = parseInt(beritaPositvePersen.toFixed(2))

        // this.valueTotalYt = this.MediaYtShare.length

        // ================================================= buble cloud
        // ================================================= buble cloud
        // ================================================= buble cloud
        // ================================================= buble cloud
        // ================================================= buble cloud

        // insialisasi word cloud
        const word = []
        let domain = '';
        this.kontenBerita.forEach((element) => {
          const get_domain = element["domain"].split(".");
          if (get_domain.length == 2) {
            domain = get_domain[0];
          } else if(get_domain.length == 3) {
            domain = get_domain[1];
          } else {
            domain = element["domain"];
          }
          word.push(domain);
        });
        const SetttWord = []
        for (let i = 0; i < word.length; i++) {
          SetttWord.push(word[i])
        }
        this.SetWord = [...new Set(SetttWord)]
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].domain.replace('.com','') == this.SetWord[0]) {
            this.wordCloudIndx0.push(data.data[i])
          }
        }
        this.wordCloudIndx1 = []
        this.wordCloudIndx2 = []
        this.wordCloudIndx3 = []
        this.wordCloudIndx4 = []
        this.words[0] = { "text" : this.SetWord[0], "weight" : this.wordCloudIndx0.length }
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].domain.replace('.com','') == this.SetWord[1]) {
            this.wordCloudIndx1.push(data.data[i])
          }
        }
        this.words[1] = { "text" : this.SetWord[1], "weight" : this.wordCloudIndx1.length }
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].domain.replace('.com','') == this.SetWord[2]) {
            this.wordCloudIndx2.push(data.data[i])
          }
        }
        this.words[2] = { "text" : this.SetWord[2], "weight" : this.wordCloudIndx2.length }
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].domain.replace('.com','') == this.SetWord[3]) {
            this.wordCloudIndx3.push(data.data[i])
          }
        }
        this.words[3] = { "text" : this.SetWord[3], "weight" : this.wordCloudIndx3.length }
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].domain.replace('.com','') == this.SetWord[4]) {
            this.wordCloudIndx4.push(data.data[i])
          }
        }
        this.words[4] = { "text" : this.SetWord[4], "weight" : this.wordCloudIndx4.length }
        // end word cloud

        // inisialisasi person
        if (this.isPerson == true) {
          const person = []
          const person2 = []
          data.data.forEach((element) => {
            if (element["ner_person"] != '' && element["ner_person"] != null) {
              person.push(element["ner_person"]);
              person2.push(element["ner_person"]);
            }
          });
          const SetttPerson = []
          const SetttPerson2 = []
          for (let i = 0; i < person.length; i++) {
            SetttPerson.push(person[i].at(-0))
            SetttPerson2.push(person2[i].at(-1))
          }

          const Setperson = [...new Set(SetttPerson)]
          const Setperson2 = [...new Set(SetttPerson2)]
          const Setperson3 = Setperson.concat(Setperson2)

          this.SetPerson = [...new Set(Setperson3)]

          this.chart_data_sort = []
          for (let x = 0; x < this.SetPerson.length; x++) {
            var jum1 = 0;
            for (let i = 0; i < data.data.length; i++) {
              if (data.data[i].ner_person != null) { //tambahan karna data ada yang null
                if (data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null) { //tambahan karna data ada yang null
                  if (data.data[i].ner_person[0] == this.SetPerson[x]) {
                    jum1++;
                  }
                }
                if (data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null) { //tambahan karna data ada yang null
                  if (data.data[i].ner_person[1] == this.SetPerson[x]) {
                    jum1++;
                  }
                }
              }
            }

            this.chart_data_sort.push({
              'name_person' : this.SetPerson[x],
              'name_person_value' : jum1
            })
          }
          this.chart_data_sort.sort(function(a,b) { // sort desc value
            return (b.name_person_value) - (a.name_person_value);
          });
          for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
            this.barchart.xaxis.categories[i] = ""
          }
          for (let i = 0; i < this.series1[0].data.length; i++) {
            this.series1[0].data[i] = ""
          }
          for (let x = 0; x < this.chart_data_sort.length; x++) {
            if (x < 6) {
              this.series1[0].data[x] = this.chart_data_sort[x].name_person_value
              this.barchart.xaxis.categories[x] = this.chart_data_sort[x].name_person
            }
          }
          for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
            if (this.barchart.xaxis.categories[i] == undefined) {
              this.barchart.xaxis.categories[i] = ""
            }
          }
        }

        if (this.isOrganisasi == true) {
          const organisasi = []
          const organisasi2 = []
          data.data.forEach((element) => {
            if (element["ner_organization"] != '' && element["ner_organization"] != null) {
              organisasi.push(element["ner_organization"]);
              organisasi2.push(element["ner_organization"]);
            }
          });
          const SetttOrganization = []
          const SetttOrganization2 = []
          for (let i = 0; i < organisasi.length; i++) {
            SetttOrganization.push(organisasi[i].at(-0))
            SetttOrganization2.push(organisasi2[i].at(-1))
          }

          const Setorganization = [...new Set(SetttOrganization)]
          const Setorganization2 = [...new Set(SetttOrganization2)]
          const Setorganization3 = Setorganization.concat(Setorganization2)

          this.SetOrganization = [...new Set(Setorganization3)]

          this.chart_data_sortOrganisasi = []
          for (let x = 0; x < this.SetOrganization.length; x++) {
            var jum1org = 0;
            for (let i = 0; i < data.data.length; i++) {
              if (data.data[i].ner_organization != null) { //tambahan karna data ada yang null
                if (data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null) { //tambahan karna data ada yang null
                  if (data.data[i].ner_organization[0] == this.SetOrganization[x]) {
                    jum1org++;
                  }
                }
                if (data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null) { //tambahan karna data ada yang null
                  if (data.data[i].ner_organization[1] == this.SetOrganization[x]) {
                    jum1org++;
                  }
                }
              }
            }

            this.chart_data_sortOrganisasi.push({
              'name_organisasi' : this.SetOrganization[x],
              'name_organisasi_value' : jum1org
            })
          }
          this.chart_data_sortOrganisasi.sort(function(a,b) { // sort desc value
            return (b.name_organisasi_value) - (a.name_organisasi_value);
          });
          for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
            this.barchart.xaxis.categories[i] = ""
          }
          for (let i = 0; i < this.series1[0].data.length; i++) {
            this.series1[0].data[i] = ""
          }
          for (let x = 0; x < this.chart_data_sortOrganisasi.length; x++) {
            if (x < 6) {
              this.series1[0].data[x] = this.chart_data_sortOrganisasi[x].name_organisasi_value
              this.barchart.xaxis.categories[x] = this.chart_data_sortOrganisasi[x].name_organisasi
            }
          }
          for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
            if (this.barchart.xaxis.categories[i] == undefined) {
              this.barchart.xaxis.categories[i] = ""
            }
          }
        }

        this.seriessentiment[0].data = [];
        this.seriessentiment[1].data = [];
        this.seriessentiment[2].data = [];
        this.seriessentiment[3].data = [];
        this.seriessentiment[0].name = "Berita Online"
        this.seriessentiment[1].name = "Twitter"
        this.seriessentiment[2].name = "Youtube"
        this.seriessentiment[3].name = ""
        this.sentimentanalysis = {...this.sentimentanalysis, ...{
          colors: ['#6F6F6F', '#FFB000', '#814AD6', '#fff']
        }}
        window.dispatchEvent(new Event('resize'))
        // this.series1 = []
        if (data.data.length > 0) {
          this.loadSentimentanalysisInisialisasi(data);
        }
        else{
          this.alert = true
          setTimeout(() => {
            this.alert = false;
          }, 4000);
          this.message = "Data Not Found"
          this.colorAlert = "red"
        }

        setTimeout(() => {
          this.dialog = false;
        }, 3000);
      } catch(e) {
        this.alert = true
        setTimeout(() => {
          this.alert = false;
        }, 3000);
        this.message = "Data Not Found"
        this.colorAlert = "red"
        this.dialog = false;
        // this.dialog = true;
        console.log('error')
        console.log(e)
      }
    },

    // ================================================================
    // ========================= sentimen =============================
    // ================================================================
    //sentimentanalysis
    async loadSentimentanalysisInisialisasi(data){
      try {
        // --- new sentiment chart
        const serisnews = []
        for (let i = 0; i < this.Settanggal.length; i++) {
          var count_serisnews = 0;
          for (let x = 0; x < this.mediaBeritaNew.length; x++) {
            if (this.mediaBeritaNew[x].date == this.Settanggal[i]) {
              count_serisnews += this.mediaBeritaNew[x].Total;
            }
          }
          serisnews.push({ x: this.Settanggal[i], y: count_serisnews });

          if (this.Settanggal.length > 1) {
            this.seriessentiment[0].data.push({ x: this.Settanggal[i], y: count_serisnews })
          }
          if (this.Settanggal.length == 1) {
            let d = new Date(this.Settanggal[0]);
            d.setUTCDate(d.getUTCDate() + 1);
            this.seriessentiment[0].data.push({ x: this.Settanggal[0], y: count_serisnews }, { x: d.toISOString().substr(0,10), y: 0 })
          }
        }

        const serismedol = []
        for (let i = 0; i < this.Settanggal.length; i++) {
          var count_serismedol = 0;
          for (let x = 0; x < this.MediatwitterShareNew.length; x++) {
            if (this.MediatwitterShareNew[x].date == this.Settanggal[i]) {
              count_serismedol += this.MediatwitterShareNew[x].Total;
            }
          }
          serismedol.push({ x: this.Settanggal[i], y: count_serismedol });
          if (this.Settanggal.length > 1) {
            this.seriessentiment[1].data.push({ x: this.Settanggal[i], y: count_serismedol })
          }
          if (this.Settanggal.length == 1) {
            let d = new Date(this.Settanggal[0]);
            d.setUTCDate(d.getUTCDate() + 1);
            this.seriessentiment[1].data.push({ x: this.Settanggal[0], y: count_serismedol }, { x: d.toISOString().substr(0,10), y: 0 })
          }
        }
        // console.log(this.MediatwitterShareNew)

        const seriesytb = []
        for (let i = 0; i < this.Settanggal.length; i++) {
          var count_seriesytb = 0;
          for (let x = 0; x < this.MediaYtShareNew.length; x++) {
            if (this.MediaYtShareNew[x].date == this.Settanggal[i]) {
              count_seriesytb += this.MediaYtShareNew[x].Total;
            }
          }
          seriesytb.push({ x: this.Settanggal[i], y: count_seriesytb });
          if (this.Settanggal.length > 1) {
            this.seriessentiment[2].data.push({ x: this.Settanggal[i], y: count_seriesytb })
          }
          if (this.Settanggal.length == 1) {
            let d = new Date(this.Settanggal[0]);
            d.setUTCDate(d.getUTCDate() + 1);
            this.seriessentiment[2].data.push({ x: this.Settanggal[0], y: count_seriesytb }, { x: d.toISOString().substr(0,10), y: 0 })
          }
        }

        window.dispatchEvent(new Event('resize'))
        // ======================================================================================= end Grafik content per sentiment
        for (let i = 0; i < data.data.length; i++) {
          // if (data.data[i].sentiment == 'Netral') {
          //   this.kontenBeritaNetral.push(data.data[i])
          // }
        }

        var sentimen_categori_psitif = 0;
        var sentimen_categori_negative = 0;
        var sentimen_categori_netral = 0;
        var total_all = 0;
        for (let i = 0; i < this.chartCombinasi.length; i++) {
          if (this.chartCombinasi[i].Positive != undefined) {
            total_all += this.chartCombinasi[i].Positive;
            sentimen_categori_psitif += this.chartCombinasi[i].Positive;
          }
          if (this.chartCombinasi[i].Negative != undefined) {
            sentimen_categori_negative += this.chartCombinasi[i].Negative;
            total_all += this.chartCombinasi[i].Negative;
          }
          if (this.chartCombinasi[i].Netral != undefined) {
            sentimen_categori_netral += this.chartCombinasi[i].Netral;
            total_all += this.chartCombinasi[i].Netral;
          }
        }
        const beritaNetralPersen = sentimen_categori_netral / total_all * 100
        this.beritaNetralPersen = parseInt(beritaNetralPersen.toFixed(2))
        const beritaNegativePersen = sentimen_categori_negative / total_all * 100
        this.beritaNegativePersen = parseInt(beritaNegativePersen.toFixed(2))
        const beritaPositvePersen = sentimen_categori_psitif / total_all * 100
        this.beritaPositifPersen = parseInt(beritaPositvePersen.toFixed(2))

        this.seriess.push(sentimen_categori_netral, sentimen_categori_negative, sentimen_categori_psitif)

        if (this.isClickWord != '' && data.data.length > 0) {
          this.onWordClick(data)
        }
        if(this.changeBackgroundColor == true){
          this.loadSentimentanalysisBerita()
        }
        if(this.changeBackgroundColorTweet == true){
          this.loadSentimentTweet()
        }
        if(this.changeBackgroundColorYt == true){
          this.loadSentimentYt()
        }
        // end update filter by buble
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      } catch (e) {
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
        console.log('error')
        console.log(e)
      }
    },

    // ================================================================
    // ========================= end sentimen =========================
    // ================================================================

    // ================================================================
    // ========================= action click =========================
    // ================================================================
    //sentimentanalysisberita
    async loadSentimentanalysisBerita() {
      if (this.changeBackgroundColor == false) {
        this.loadKontenBerita2()
      }
      if (this.changeBackgroundColor == true) {
        // alert('aaa');
        this.$refs.topPersonComponent.loadSentimentanalysisBerita();
        this.dialog = true
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
        try {
          window.dispatchEvent(new Event('resize'))
          this.click = 'berita'
          if (this.click == 'berita') {
            this.seriess = []
            // this.seriess.push(this.mediaBeritaNetral.length, this.mediaBeritaNegative.length, this.mediaBeritaPositive.length)
            this.seriess.push(this.count_chart_mediaBeritaNetral, this.count_chart_mediaBeritaNegative, this.count_chart_mediaBeritaPositive)
            // insialisasi word cloud
            const word = []
            let domain = '';
            this.mediaBerita.forEach((element) => {
              console.log(element["domain"])
              const get_domain = element["domain"].split(".");
              if (get_domain.length == 2) {
                domain = get_domain[0];
              } else if(get_domain.length == 3) {
                domain = get_domain[1];
              } else {
                domain = element["domain"];
              }
              word.push(domain);
            });
            const SetttWord = []
            for (let i = 0; i < word.length; i++) {
              SetttWord.push(word[i])
            }
            this.SetWord = [...new Set(SetttWord)]
            this.wordCloudIndx0 = []
            for (let i = 0; i < this.mediaBerita.length; i++) {
              if (this.mediaBerita[i].domain.replace('.com','') == this.SetWord[0]) {
                this.wordCloudIndx0.push(this.mediaBerita[i])
              }
            }
            this.wordCloudIndx1 = []
            this.wordCloudIndx2 = []
            this.wordCloudIndx3 = []
            this.wordCloudIndx4 = []
            this.words[0] = { "text" : this.SetWord[0], "weight" : this.wordCloudIndx0.length }
            for (let i = 0; i < this.mediaBerita.length; i++) {
              if (this.mediaBerita[i].domain.replace('.com','') == this.SetWord[1]) {
                this.wordCloudIndx1.push(this.mediaBerita[i])
              }
            }
            this.words[1] = { "text" : this.SetWord[1], "weight" : this.wordCloudIndx1.length }
            for (let i = 0; i < this.mediaBerita.length; i++) {
              if (this.mediaBerita[i].domain.replace('.com','') == this.SetWord[2]) {
                this.wordCloudIndx2.push(this.mediaBerita[i])
              }
            }
            this.words[2] = { "text" : this.SetWord[2], "weight" : this.wordCloudIndx2.length }
            for (let i = 0; i < this.mediaBerita.length; i++) {
              if (this.mediaBerita[i].domain.replace('.com','') == this.SetWord[3]) {
                this.wordCloudIndx3.push(this.mediaBerita[i])
              }
            }
            this.words[3] = { "text" : this.SetWord[3], "weight" : this.wordCloudIndx3.length }
            for (let i = 0; i < this.mediaBerita.length; i++) {
              if (this.mediaBerita[i].domain.replace('.com','') == this.SetWord[4]) {
                this.wordCloudIndx4.push(this.mediaBerita[i])
              }
            }
            this.words[4] = { "text" : this.SetWord[4], "weight" : this.wordCloudIndx4.length }
            // end word cloud

            if (this.isPerson == true) {
              const person = []
              const person2 = []
              this.mediaBerita.forEach((element) => {
                console.log(element["ner_person"])
                if (element["ner_person"] != '' && element["ner_person"] != null) {
                  person.push(element["ner_person"]);
                  person2.push(element["ner_person"]);
                }
              });
              const SetttPerson = []
              const SetttPerson2 = []
              for (let i = 0; i < person.length; i++) {
                SetttPerson.push(person[i].at(-0))
                SetttPerson2.push(person2[i].at(-1))
              }

              const Setperson = [...new Set(SetttPerson)]
              const Setperson2 = [...new Set(SetttPerson2)]
              const Setperson3 = Setperson.concat(Setperson2)

              this.SetPerson = [...new Set(Setperson3)]

              this.chart_data_sort = []
              for (let x = 0; x < this.SetPerson.length; x++) {
                var jum1 = 0;
                for (let i = 0; i < this.mediaBerita.length; i++) {
                  if (this.mediaBerita[i].ner_person != null) { //tambahan karna data ada yang null
                    if (this.mediaBerita[i].ner_person[0] != '' && this.mediaBerita[i].ner_person[0] != null) { //tambahan karna data ada yang null
                      if (this.mediaBerita[i].ner_person[0] == this.SetPerson[x]) {
                        jum1++;
                      }
                    }
                    if (this.mediaBerita[i].ner_person[1] != '' && this.mediaBerita[i].ner_person[1] != null) { //tambahan karna data ada yang null
                      if (this.mediaBerita[i].ner_person[1] == this.SetPerson[x]) {
                        jum1++;
                      }
                    }
                  }
                }

                this.chart_data_sort.push({
                  'name_person' : this.SetPerson[x],
                  'name_person_value' : jum1
                })
              }
              this.chart_data_sort.sort(function(a,b) { // sort desc value
                return (b.name_person_value) - (a.name_person_value);
              });
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                this.barchart.xaxis.categories[i] = ""
              }
              for (let i = 0; i < this.series1[0].data.length; i++) {
                this.series1[0].data[i] = ""
              }
              for (let x = 0; x < this.chart_data_sort.length; x++) {
                if (x < 6) {
                  this.series1[0].data[x] = this.chart_data_sort[x].name_person_value
                  this.barchart.xaxis.categories[x] = this.chart_data_sort[x].name_person
                }
              }

              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                if (this.barchart.xaxis.categories[i] == undefined) {
                  this.barchart.xaxis.categories[i] = ""
                }
              }
            }

            if (this.isOrganisasi == true) {
              const organisasi = []
              const organisasi2 = []
              this.mediaBerita.forEach((element) => {
                if (element["ner_organization"] != '' && element["ner_organization"] != null) {
                  organisasi.push(element["ner_organization"]);
                  organisasi2.push(element["ner_organization"]);
                }
              });
              const SetttOrganization = []
              const SetttOrganization2 = []
              for (let i = 0; i < organisasi.length; i++) {
                SetttOrganization.push(organisasi[i].at(-0))
                SetttOrganization2.push(organisasi2[i].at(-1))
              }

              const Setorganization = [...new Set(SetttOrganization)]
              const Setorganization2 = [...new Set(SetttOrganization2)]
              const Setorganization3 = Setorganization.concat(Setorganization2)

              this.SetOrganization = [...new Set(Setorganization3)]

              this.chart_data_sortOrganisasi = []
              for (let x = 0; x < this.SetOrganization.length; x++) {
                var jum1org = 0;
                for (let i = 0; i < this.mediaBerita.length; i++) {
                  if (this.mediaBerita[i].ner_organization != null) { //tambahan karna data ada yang null
                    if (this.mediaBerita[i].ner_organization[0] != '' && this.mediaBerita[i].ner_organization[0] != null) { //tambahan karna data ada yang null
                      if (this.mediaBerita[i].ner_organization[0] == this.SetOrganization[x]) {
                        jum1org++;
                      }
                    }
                    if (this.mediaBerita[i].ner_organization[1] != '' && this.mediaBerita[i].ner_organization[1] != null) { //tambahan karna data ada yang null
                      if (this.mediaBerita[i].ner_organization[1] == this.SetOrganization[x]) {
                        jum1org++;
                      }
                    }
                  }
                }

                this.chart_data_sortOrganisasi.push({
                  'name_organisasi' : this.SetOrganization[x],
                  'name_organisasi_value' : jum1org
                })
              }
              this.chart_data_sortOrganisasi.sort(function(a,b) { // sort desc value
                return (b.name_organisasi_value) - (a.name_organisasi_value);
              });
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                this.barchart.xaxis.categories[i] = ""
              }
              for (let i = 0; i < this.series1[0].data.length; i++) {
                this.series1[0].data[i] = ""
              }
              for (let x = 0; x < this.chart_data_sortOrganisasi.length; x++) {
                if (x < 6) {
                  this.series1[0].data[x] = this.chart_data_sortOrganisasi[x].name_organisasi_value
                  this.barchart.xaxis.categories[x] = this.chart_data_sortOrganisasi[x].name_organisasi
                }
              }
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                if (this.barchart.xaxis.categories[i] == undefined) {
                  this.barchart.xaxis.categories[i] = ""
                }
              }
            }

            this.kontenBeritaPositive = []
            this.kontenBeritaNegative = []
            this.kontenBeritaNetral = []
            for (let i = 0; i < this.mediaBerita.length; i++) {
              if (this.mediaBerita[i].sentiment == 'Positive') {
                this.kontenBeritaPositive.push(this.mediaBerita[i]);
              }
            }
            for (let i = 0; i < this.mediaBerita.length; i++) {
              if (this.mediaBerita[i].sentiment == 'Negative') {
                this.kontenBeritaNegative.push(this.mediaBerita[i]);
              }
            }
            for (let i = 0; i < this.mediaBerita.length; i++) {
              if (this.mediaBerita[i].sentiment == 'Netral') {
                this.kontenBeritaNetral.push(this.mediaBerita[i]);
              }
            }

            const beritaNetralPersen = this.kontenBeritaNetral.length / this.mediaBerita.length * 100
            this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
            const beritaNegativePersen = this.kontenBeritaNegative.length / this.mediaBerita.length * 100
            this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
            const beritaPositvePersen = this.kontenBeritaPositive.length / this.mediaBerita.length * 100
            this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
            this.kontenBerita = this.mediaBerita
            this.pagelength = Math.ceil(this.kontenBerita.length / 100)

            this.seriessentiment[0].data = [];
            this.seriessentiment[1].data = [];
            this.seriessentiment[2].data = [];
            this.seriessentiment[3].data = [];
            const serisnews = [];
            const serisnewsNetral = [];
            const serisnewsNegative = [];
            const serisnewsPositive = [];
            for (let i = 0; i < this.Settanggal.length; i++) {
              var count_serisnews = 0;
              var count_serisnewsNetral = 0;
              var count_serisnewsNegative = 0;
              var count_serisnewsPositive = 0;
              for (let x = 0; x < this.mediaBeritaNew.length; x++) {
                if (this.mediaBeritaNew[x].date == this.Settanggal[i]) {
                  count_serisnews += this.mediaBeritaNew[x].Total;
                }
              }
              for (let x = 0; x < this.mediaBeritaNew.length; x++) {
                if (this.mediaBeritaNew[x].date == this.Settanggal[i]) {
                  if (this.mediaBeritaNew[x].Netral != undefined) {
                    count_serisnewsNetral += this.mediaBeritaNew[x].Netral;
                  }
                }
              }
              for (let x = 0; x < this.mediaBeritaNew.length; x++) {
                if (this.mediaBeritaNew[x].date == this.Settanggal[i]) {
                  if (this.mediaBeritaNew[x].Negative != undefined) {
                    count_serisnewsNegative += this.mediaBeritaNew[x].Negative;
                  }
                }
              }
              for (let x = 0; x < this.mediaBeritaNew.length; x++) {
                if (this.mediaBeritaNew[x].date == this.Settanggal[i]) {
                  if (this.mediaBeritaNew[x].Positive != undefined) {
                    count_serisnewsPositive += this.mediaBeritaNew[x].Positive;
                  }
                }
              }
              serisnews.push({x:this.Settanggal[i],y:count_serisnews});
              serisnewsNetral.push({x:this.Settanggal[i],y:count_serisnewsNetral});
              serisnewsNegative.push({x:this.Settanggal[i],y:count_serisnewsNegative});
              serisnewsPositive.push({x:this.Settanggal[i],y:count_serisnewsPositive});

              this.seriessentiment[0].name = "Netral"
              this.seriessentiment[1].name = "Negative"
              this.seriessentiment[2].name = "Positive"

              this.sentimentanalysis = {...this.sentimentanalysis, ...{
                colors: ['#008FFB', '#FF4560', '#00E396', "fff"]
              }}

              if(this.Settanggal.length > 1){
                this.seriessentiment[0].data.push({x:this.Settanggal[i],y:count_serisnewsNetral})
                this.seriessentiment[1].data.push({x:this.Settanggal[i],y:count_serisnewsNegative})
                this.seriessentiment[2].data.push({x:this.Settanggal[i],y:count_serisnewsPositive})
              }
              if(this.Settanggal.length == 1){
                let d = new Date(this.Settanggal[0]);
                d.setUTCDate(d.getUTCDate() + 1);
                // this.seriessentiment[0].data.push({x:this.Settanggal[0],y:count_serisnews},{x:d.toISOString().substr(0,10),y:0})
                this.seriessentiment[0].data.push({x:this.Settanggal[0],y:count_serisnewsNetral},{x:d.toISOString().substr(0,10),y:0})
                this.seriessentiment[1].data.push({x:this.Settanggal[0],y:count_serisnewsNegative},{x:d.toISOString().substr(0,10),y:0})
                this.seriessentiment[2].data.push({x:this.Settanggal[0],y:count_serisnewsPositive},{x:d.toISOString().substr(0,10),y:0})
              }
            }
            window.dispatchEvent(new Event("resize"));
          }
        } catch (e) {
          console.log('error')
          console.log(e)
        }
      }
    },

    // ================================================================== handle pagination content

    async handlePageChange(value) {
      this.dialog = true;

      let sentiment_search = this.$store.sentiment_glob
      if (this.$store.sentiment_glob == '' || this.$store.sentiment_glob == undefined) {
        sentiment_search = ""
      }
      let ner_person_search = this.$store.ner_person_glob
      if (this.$store.ner_person_glob == '' || this.$store.ner_person_glob == undefined) {
        ner_person_search = ""
      }
      let ner_organization_search = this.$store.ner_organization_glob
      if (this.$store.ner_organization_glob == '' || this.$store.ner_organization_glob == undefined) {
        ner_organization_search = ""
      }
      let object_filter_logika = this.$store.finalobjectfilterlogika_glob
      if (this.$store.finalobjectfilterlogika_glob == "" || this.$store.finalobjectfilterlogika_glob == undefined) {
        object_filter_logika = ""
      }

      const startPage = this.pageplay * (value-1)
      try {
        const data1 = await axios
          .get("solr-new?start_date=" + this.$store.date_start_glob + "&end_date=" + this.$store.date_end_glob + "&topic=" + this.$store.topic_glob + "&sentiment=" + sentiment_search + "&ner_person=" + ner_person_search + "&ner_organization=" + ner_organization_search + "&logic=" + JSON.stringify(object_filter_logika) + "&start=" + startPage + "&rows=" + this.pageplay)
        const data = data1.data;

        this.mediaBeritaNetral = []
        this.mediaBeritaNegative = []
        this.mediaBeritaPositive = []
        this.mediaTweetNetral = []
        this.mediaTweetNegative = []
        this.mediaTweetPositive = []
        this.mediaYtNetral = []
        this.mediaYtNegative = []
        this.mediaYtPositive = []
        // end pie edol dan mednewa
        // to content Count
        this.mediaBerita = []
        this.MediatwitterShare = []
        this.MediaYtShare = []
        this.kontenBerita = data.data
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].source == 'berita') {
            this.mediaBerita.push(data.data[i]);
          }
        }
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].source == 'twitter') {
            this.MediatwitterShare.push(data.data[i]);
          }
        }
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].source == 'youtube') {
            this.MediaYtShare.push(data.data[i]);
          }
        }
        this.kontenBeritaPositive = []
        this.kontenBeritaNegative = []
        this.kontenBeritaNetral = []
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == 'Netral') {
            this.kontenBeritaNetral.push(data.data[i]);
          }
        }
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == 'Negative') {
            this.kontenBeritaNegative.push(data.data[i]);
          }
        }
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == 'Positive') {
            this.kontenBeritaPositive.push(data.data[i]);
          }
        }
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      } catch (e) {
        console.log('error')
      }
    },
    //load sentiment twet
    async loadSentimentTweet() {
      if (this.changeBackgroundColorTweet == false) {
        this.loadKontenBerita2()
      }
      if (this.changeBackgroundColorTweet == true) {
        this.dialog = true
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
        try {
          this.click = 'twitter'
          if (this.click == 'twitter') {
            this.seriessentiment[0].data = [];
            this.seriessentiment[1].data = [];
            this.seriessentiment[2].data = [];
            this.seriessentiment[3].data = [];
            const serisnews = [];
            const serisnewsNetral = [];
            const serisnewsNegative = [];
            const serisnewsPositive = [];
            for (let i = 0; i < this.Settanggal.length; i++) {
              var count_serisnews = 0;
              var count_serisnewsNetral = 0;
              var count_serisnewsNegative = 0;
              var count_serisnewsPositive = 0;
              for (let x = 0; x < this.MediatwitterShareNew.length; x++) {
                if (this.MediatwitterShareNew[x].date == this.Settanggal[i]) {
                  count_serisnews += this.MediatwitterShareNew[x].Total;
                }
              }
              for (let x = 0; x < this.MediatwitterShareNew.length; x++) {
                if (this.MediatwitterShareNew[x].date == this.Settanggal[i]) {
                  if (this.MediatwitterShareNew[x].Netral != undefined) {
                    count_serisnewsNetral += this.MediatwitterShareNew[x].Netral;
                  }
                }
              }
              for (let x = 0; x < this.MediatwitterShareNew.length; x++) {
                if (this.MediatwitterShareNew[x].date == this.Settanggal[i]) {
                  if (this.MediatwitterShareNew[x].Negative != undefined) {
                    count_serisnewsNegative += this.MediatwitterShareNew[x].Negative;
                  }
                }
              }
              for (let x = 0; x < this.MediatwitterShareNew.length; x++) {
                if (this.MediatwitterShareNew[x].date == this.Settanggal[i]) {
                  if (this.MediatwitterShareNew[x].Positive != undefined) {
                    count_serisnewsPositive += this.MediatwitterShareNew[x].Positive;
                  }
                }
              }
              serisnews.push({x:this.Settanggal[i],y:count_serisnews});
              serisnewsNetral.push({x:this.Settanggal[i],y:count_serisnewsNetral});
              serisnewsNegative.push({x:this.Settanggal[i],y:count_serisnewsNegative});
              serisnewsPositive.push({x:this.Settanggal[i],y:count_serisnewsPositive});

              // this.seriessentiment[0].name = "Twitter"
              this.seriessentiment[0].name = "Netral"
              this.seriessentiment[1].name = "Negative"
              this.seriessentiment[2].name = "Positive"

              this.sentimentanalysis = {...this.sentimentanalysis, ...{
                colors:['#008FFB', '#FF4560', '#00E396', "fff"]
              }}

              if(this.Settanggal.length > 1){
                // this.seriessentiment[0].data.push({x:this.Settanggal[i],y:count_serisnews})
                this.seriessentiment[0].data.push({x:this.Settanggal[i],y:count_serisnewsNetral})
                this.seriessentiment[1].data.push({x:this.Settanggal[i],y:count_serisnewsNegative})
                this.seriessentiment[2].data.push({x:this.Settanggal[i],y:count_serisnewsPositive})
              }
              if(this.Settanggal.length == 1){
                let d = new Date(this.Settanggal[0]);
                d.setUTCDate(d.getUTCDate() + 1);
                this.seriessentiment[0].data.push({x:this.Settanggal[0],y:count_serisnews},{x:d.toISOString().substr(0,10),y:0})
                this.seriessentiment[1].data.push({x:this.Settanggal[0],y:count_serisnewsNetral},{x:d.toISOString().substr(0,10),y:0})
                this.seriessentiment[2].data.push({x:this.Settanggal[0],y:count_serisnewsNegative},{x:d.toISOString().substr(0,10),y:0})
                this.seriessentiment[3].data.push({x:this.Settanggal[0],y:count_serisnewsPositive},{x:d.toISOString().substr(0,10),y:0})
              }
            }

            window.dispatchEvent(new Event('resize'))
            this.$refs.topPersonComponent.loadSentimentTweet();
            // insialisasi word cloud
            const word = []
            let domain = '';
            this.MediatwitterShare.forEach((element) => {
              console.log(element["domain"])
              const get_domain = element["domain"].split(".");
              if (get_domain.length == 2) {
                domain = get_domain[0];
              } else if(get_domain.length == 3) {
                domain = get_domain[1];
              } else {
                domain = element["domain"];
              }
              word.push(domain);
            });
            const SetttWord = []
            for (let i = 0; i < word.length; i++) {
              SetttWord.push(word[i])
            }
            this.SetWord = [...new Set(SetttWord)]
            this.wordCloudIndx0 = []
            for (let i = 0; i < this.MediatwitterShare.length; i++) {
              if (this.MediatwitterShare[i].domain.replace('.com','') == this.SetWord[0]) {
                this.wordCloudIndx0.push(this.MediatwitterShare[i])
              }
            }
            this.wordCloudIndx1 = []
            this.wordCloudIndx2 = []
            this.wordCloudIndx3 = []
            this.wordCloudIndx4 = []
            this.words[0] = { "text" : this.SetWord[0], "weight" : this.wordCloudIndx0.length }
            for (let i = 0; i < this.MediatwitterShare.length; i++) {
              if (this.MediatwitterShare[i].domain.replace('.com','') == this.SetWord[1]) {
                this.wordCloudIndx1.push(this.MediatwitterShare[i])
              }
            }
            this.words[1] = { "text" : this.SetWord[1], "weight" : this.wordCloudIndx1.length }
            for (let i = 0; i < this.MediatwitterShare.length; i++) {
              if (this.MediatwitterShare[i].domain.replace('.com','') == this.SetWord[2]) {
                this.wordCloudIndx2.push(this.MediatwitterShare[i])
              }
            }
            this.words[2] = { "text" : this.SetWord[2], "weight" : this.wordCloudIndx2.length }
            for (let i = 0; i < this.MediatwitterShare.length; i++) {
              if (this.MediatwitterShare[i].domain.replace('.com','') == this.SetWord[3]) {
                this.wordCloudIndx3.push(this.MediatwitterShare[i])
              }
            }
            this.words[3] = { "text" : this.SetWord[3], "weight" : this.wordCloudIndx3.length }
            for (let i = 0; i < this.MediatwitterShare.length; i++) {
              if (this.MediatwitterShare[i].domain.replace('.com','') == this.SetWord[4]) {
                this.wordCloudIndx4.push(this.MediatwitterShare[i])
              }
            }
            this.words[4] = { "text" : this.SetWord[4], "weight" : this.wordCloudIndx4.length }
            // end word cloud

            if (this.isPerson == true) {
              const person = []
              const person2 = []
              this.MediatwitterShare.forEach((element) => {
                console.log(element["ner_person"])
                if (element["ner_person"] != '' && element["ner_person"] != null) {
                  person.push(element["ner_person"]);
                  person2.push(element["ner_person"]);
                }
              });
              const SetttPerson = []
              const SetttPerson2 = []
              for (let i = 0; i < person.length; i++) {
                SetttPerson.push(person[i].at(-0))
                SetttPerson2.push(person2[i].at(-1))
              }

              const Setperson = [...new Set(SetttPerson)]
              const Setperson2 = [...new Set(SetttPerson2)]
              const Setperson3 = Setperson.concat(Setperson2)

              this.SetPerson = [...new Set(Setperson3)]

              this.chart_data_sort = []
              for (let x = 0; x < this.SetPerson.length; x++) {
                var jum1 = 0;
                for (let i = 0; i < this.MediatwitterShare.length; i++) {
                  if (this.MediatwitterShare[i].ner_person != null) { //tambahan karna data ada yang null
                    if (this.MediatwitterShare[i].ner_person[0] != '' && this.MediatwitterShare[i].ner_person[0] != null) { //tambahan karna data ada yang null
                      if (this.MediatwitterShare[i].ner_person[0] == this.SetPerson[x]) {
                        jum1++;
                      }
                    }
                    if (this.MediatwitterShare[i].ner_person[1] != '' && this.MediatwitterShare[i].ner_person[1] != null) { //tambahan karna data ada yang null
                      if (this.MediatwitterShare[i].ner_person[1] == this.SetPerson[x]) {
                        jum1++;
                      }
                    }
                  }
                }

                this.chart_data_sort.push({
                  'name_person' : this.SetPerson[x],
                  'name_person_value' : jum1
                })
              }
              this.chart_data_sort.sort(function(a,b) { // sort desc value
                return (b.name_person_value) - (a.name_person_value);
              });
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                this.barchart.xaxis.categories[i] = ""
              }
              for (let i = 0; i < this.series1[0].data.length; i++) {
                this.series1[0].data[i] = ""
              }
              for (let x = 0; x < this.chart_data_sort.length; x++) {
                if (x < 6) {
                  this.series1[0].data[x] = this.chart_data_sort[x].name_person_value
                  this.barchart.xaxis.categories[x] = this.chart_data_sort[x].name_person
                }
              }
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                if (this.barchart.xaxis.categories[i] == undefined) {
                  this.barchart.xaxis.categories[i] = ""
                }
              }
            }

            if (this.isOrganisasi == true) {
              const organisasi = []
              const organisasi2 = []
              this.MediatwitterShare.forEach((element) => {
                if (element["ner_organization"] != '' && element["ner_organization"] != null) {
                  organisasi.push(element["ner_organization"]);
                  organisasi2.push(element["ner_organization"]);
                }
              });
              const SetttOrganization = []
              const SetttOrganization2 = []
              for (let i = 0; i < organisasi.length; i++) {
                SetttOrganization.push(organisasi[i].at(-0))
                SetttOrganization2.push(organisasi2[i].at(-1))
              }

              const Setorganization = [...new Set(SetttOrganization)]
              const Setorganization2 = [...new Set(SetttOrganization2)]
              const Setorganization3 = Setorganization.concat(Setorganization2)

              this.SetOrganization = [...new Set(Setorganization3)]

              this.chart_data_sortOrganisasi = []
              for (let x = 0; x < this.SetOrganization.length; x++) {
                var jum1org = 0;
                for (let i = 0; i < this.MediatwitterShare.length; i++) {
                  if (this.MediatwitterShare[i].ner_organization != null) { //tambahan karna data ada yang null
                    if (this.MediatwitterShare[i].ner_organization[0] != '' && this.MediatwitterShare[i].ner_organization[0] != null) { //tambahan karna data ada yang null
                      if (this.MediatwitterShare[i].ner_organization[0] == this.SetOrganization[x]) {
                        jum1org++;
                      }
                    }
                    if (this.MediatwitterShare[i].ner_organization[1] != '' && this.MediatwitterShare[i].ner_organization[1] != null) { //tambahan karna data ada yang null
                      if (this.MediatwitterShare[i].ner_organization[1] == this.SetOrganization[x]) {
                        jum1org++;
                      }
                    }
                  }
                }

                this.chart_data_sortOrganisasi.push({
                  'name_organisasi' : this.SetOrganization[x],
                  'name_organisasi_value' : jum1org
                })
              }
              this.chart_data_sortOrganisasi.sort(function(a,b) { // sort desc value
                return (b.name_organisasi_value) - (a.name_organisasi_value);
              });
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                this.barchart.xaxis.categories[i] = ""
              }
              for (let i = 0; i < this.series1[0].data.length; i++) {
                this.series1[0].data[i] = ""
              }
              for (let x = 0; x < this.chart_data_sortOrganisasi.length; x++) {
                if (x < 6) {
                  this.series1[0].data[x] = this.chart_data_sortOrganisasi[x].name_organisasi_value
                  this.barchart.xaxis.categories[x] = this.chart_data_sortOrganisasi[x].name_organisasi
                }
              }
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                if (this.barchart.xaxis.categories[i] == undefined) {
                  this.barchart.xaxis.categories[i] = ""
                }
              }
            }
            this.seriess = []
            // this.seriess.push(this.kontenTwitterNetral.length, this.kontenTwitterNegative.length, this.kontenTwitterPositive.length)
            this.seriess.push(this.count_chart_kontenTwitterNetral, this.count_chart_kontenTwitterNegative, this.count_chart_kontenTwitterPositive)
            // this.seriess.push(30, 40, 500)
            // alert(this.MediatwitterShare.length);
            this.kontenBeritaNetral = this.kontenTwitterNetral
            this.kontenBeritaNegative = this.kontenTwitterNegative
            this.kontenBeritaPositive = this.kontenTwitterPositive
            const beritaNetralPersen = this.kontenTwitterNetral.length / this.MediatwitterShare.length * 100
            this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
            const beritaNegativePersen = this.kontenTwitterNegative.length / this.MediatwitterShare.length * 100
            this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
            const beritaPositvePersen = this.kontenTwitterPositive.length / this.MediatwitterShare.length * 100
            this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
            this.kontenBerita = this.MediatwitterShare
            this.pagelength = Math.ceil(this.kontenBerita.length / 100)
          }
        } catch (e) {
          console.log('error')
          console.log(e)
        }
      }
    },
    //load sentiment yt
    async loadSentimentYt(){
      if (this.changeBackgroundColorYt == false) {
        this.loadKontenBerita2()
      }
      if (this.changeBackgroundColorYt == true) {
        this.dialog = true
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
        try {
          this.click = 'youtube'
          if (this.click == 'youtube') {
            this.seriessentiment[0].data = [];
            this.seriessentiment[1].data = [];
            this.seriessentiment[2].data = [];
            this.seriessentiment[3].data = [];
            const serisnews = []
            const serisnewsNetral = []
            const serisnewsNegative = []
            const serisnewsPositive = []
            for (let i = 0; i < this.Settanggal.length; i++) {
              var count_serisnews = 0;
              var count_serisnewsNetral = 0;
              var count_serisnewsNegative = 0;
              var count_serisnewsPositive = 0;
              for (let x = 0; x < this.MediaYtShareNew.length; x++) {
                if (this.MediaYtShareNew[x].date == this.Settanggal[i]) {
                  count_serisnews += this.MediaYtShareNew[x].Total;
                }
              }
              for (let x = 0; x < this.MediaYtShareNew.length; x++) {
                if (this.MediaYtShareNew[x].date == this.Settanggal[i]) {
                  if (this.MediaYtShareNew[x].Netral != undefined) {
                    count_serisnewsNetral += this.MediaYtShareNew[x].Netral;
                  }
                }
              }
              for (let x = 0; x < this.MediaYtShareNew.length; x++) {
                if (this.MediaYtShareNew[x].date == this.Settanggal[i]) {
                  if (this.MediaYtShareNew[x].Negative != undefined) {
                    count_serisnewsNegative += this.MediaYtShareNew[x].Negative;
                  }
                }
              }
              for (let x = 0; x < this.MediaYtShareNew.length; x++) {
                if (this.MediaYtShareNew[x].date == this.Settanggal[i]) {
                  if (this.MediaYtShareNew[x].Positive != undefined) {
                    count_serisnewsPositive += this.MediaYtShareNew[x].Positive;
                  }
                }
              }
              serisnews.push({ x: this.Settanggal[i], y: count_serisnews });
              serisnewsNetral.push({ x: this.Settanggal[i], y: count_serisnewsNetral });
              serisnewsNegative.push({ x: this.Settanggal[i], y: count_serisnewsNegative });
              serisnewsPositive.push({ x: this.Settanggal[i], y: count_serisnewsPositive });

              // this.seriessentiment[0].name = "Youtube"
              this.seriessentiment[0].name = "Netral"
              this.seriessentiment[1].name = "Negative"
              this.seriessentiment[2].name = "Positive"

              this.sentimentanalysis = {...this.sentimentanalysis, ...{
                colors:['#008FFB', '#FF4560', '#00E396', "fff"]
              }}

              if(this.Settanggal.length > 1){
                // this.seriessentiment[0].data.push({x:this.Settanggal[i],y:count_serisnews})
                this.seriessentiment[0].data.push({x:this.Settanggal[i],y:count_serisnewsNetral})
                this.seriessentiment[1].data.push({x:this.Settanggal[i],y:count_serisnewsNegative})
                this.seriessentiment[2].data.push({x:this.Settanggal[i],y:count_serisnewsPositive})
              }
              if(this.Settanggal.length == 1){
                let d = new Date(this.Settanggal[0]);
                d.setUTCDate(d.getUTCDate() + 1);
                this.seriessentiment[0].data.push({x:this.Settanggal[0],y:count_serisnews},{x:d.toISOString().substr(0,10),y:0})
                this.seriessentiment[1].data.push({x:this.Settanggal[0],y:count_serisnewsNetral},{x:d.toISOString().substr(0,10),y:0})
                this.seriessentiment[2].data.push({x:this.Settanggal[0],y:count_serisnewsNegative},{x:d.toISOString().substr(0,10),y:0})
                this.seriessentiment[3].data.push({x:this.Settanggal[0],y:count_serisnewsPositive},{x:d.toISOString().substr(0,10),y:0})
              }
            }

            window.dispatchEvent(new Event('resize'))

            this.$refs.topPersonComponent.loadSentimentYt();
            this.seriess = []
            // this.seriess.push(this.kontenYoutubeNetral.length, this.kontenYoutubeNegative.length, this.kontenYoutubePositive.length)
            this.seriess.push(this.count_chart_kontenYoutubeNetral, this.count_chart_kontenYoutubeNegative, this.count_chart_kontenYoutubePositive)
            // insialisasi word cloud
            const word = []
            let domain = '';
            this.MediaYtShare.forEach((element) => {
              console.log(element["domain"])
              const get_domain = element["domain"].split(".");
              if (get_domain.length == 2) {
                domain = get_domain[0];
              } else if(get_domain.length == 3) {
                domain = get_domain[1];
              } else {
                domain = element["domain"];
              }
              word.push(domain);
            });
            const SetttWord = []
            for (let i = 0; i < word.length; i++) {
              SetttWord.push(word[i])
            }
            this.SetWord = [...new Set(SetttWord)]
            this.wordCloudIndx0 = []
            for (let i = 0; i < this.MediaYtShare.length; i++) {
              if (this.MediaYtShare[i].domain.replace('.com','') == this.SetWord[0]) {
                this.wordCloudIndx0.push(this.MediaYtShare[i])
              }
            }
            this.wordCloudIndx1 = []
            this.wordCloudIndx2 = []
            this.wordCloudIndx3 = []
            this.wordCloudIndx4 = []
            this.words[0] = { "text" : this.SetWord[0], "weight" : this.wordCloudIndx0.length }
            for (let i = 0; i < this.MediaYtShare.length; i++) {
              if (this.MediaYtShare[i].domain.replace('.com','') == this.SetWord[1]) {
                this.wordCloudIndx1.push(this.MediaYtShare[i])
              }
            }
            this.words[1] = { "text" : this.SetWord[1], "weight" : this.wordCloudIndx1.length }
            for (let i = 0; i < this.MediaYtShare.length; i++) {
              if (this.MediaYtShare[i].domain.replace('.com','') == this.SetWord[2]) {
                this.wordCloudIndx2.push(this.MediaYtShare[i])
              }
            }
            this.words[2] = { "text" : this.SetWord[2], "weight" : this.wordCloudIndx2.length }
            for (let i = 0; i < this.MediaYtShare.length; i++) {
              if (this.MediaYtShare[i].domain.replace('.com','') == this.SetWord[3]) {
                this.wordCloudIndx3.push(this.MediaYtShare[i])
              }
            }
            this.words[3] = { "text" : this.SetWord[3], "weight" : this.wordCloudIndx3.length }
            for (let i = 0; i < this.MediaYtShare.length; i++) {
              if (this.MediaYtShare[i].domain.replace('.com','') == this.SetWord[4]) {
                this.wordCloudIndx4.push(this.MediaYtShare[i])
              }
            }
            this.words[4] = { "text" : this.SetWord[4], "weight" : this.wordCloudIndx4.length }
            // end word cloud

            if (this.isPerson == true) {
              const person = []
              const person2 = []
              this.MediaYtShare.forEach((element) => {
                console.log(element["ner_person"])
                if (element["ner_person"] != '' && element["ner_person"] != null) {
                  person.push(element["ner_person"]);
                  person2.push(element["ner_person"]);
                }
              });
              const SetttPerson = []
              const SetttPerson2 = []
              for (let i = 0; i < person.length; i++) {
                SetttPerson.push(person[i].at(-0))
                SetttPerson2.push(person2[i].at(-1))
              }

              const Setperson = [...new Set(SetttPerson)]
              const Setperson2 = [...new Set(SetttPerson2)]
              const Setperson3 = Setperson.concat(Setperson2)

              this.SetPerson = [...new Set(Setperson3)]

              this.chart_data_sort = []
              for (let x = 0; x < this.SetPerson.length; x++) {
                var jum1 = 0;
                for (let i = 0; i < this.MediaYtShare.length; i++) {
                  if (this.MediaYtShare[i].ner_person != null) { //tambahan karna data ada yang null
                    if (this.MediaYtShare[i].ner_person[0] != '' && this.MediaYtShare[i].ner_person[0] != null) { //tambahan karna data ada yang null
                      if (this.MediaYtShare[i].ner_person[0] == this.SetPerson[x]) {
                        jum1++;
                      }
                    }
                    if (this.MediaYtShare[i].ner_person[1] != '' && this.MediaYtShare[i].ner_person[1] != null) { //tambahan karna data ada yang null
                      if (this.MediaYtShare[i].ner_person[1] == this.SetPerson[x]) {
                        jum1++;
                      }
                    }
                  }
                }

                this.chart_data_sort.push({
                  'name_person' : this.SetPerson[x],
                  'name_person_value' : jum1
                })
              }
              this.chart_data_sort.sort(function(a,b) { // sort desc value
                return (b.name_person_value) - (a.name_person_value);
              });
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                this.barchart.xaxis.categories[i] = ""
              }
              for (let i = 0; i < this.series1[0].data.length; i++) {
                this.series1[0].data[i] = ""
              }
              for (let x = 0; x < this.chart_data_sort.length; x++) {
                if (x < 6) {
                  this.series1[0].data[x] = this.chart_data_sort[x].name_person_value
                  this.barchart.xaxis.categories[x] = this.chart_data_sort[x].name_person
                }
              }
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                if (this.barchart.xaxis.categories[i] == undefined) {
                  this.barchart.xaxis.categories[i] = ""
                }
              }
            }

            if (this.isOrganisasi == true) {
              const organisasi = []
              const organisasi2 = []
              this.MediaYtShare.forEach((element) => {
                if (element["ner_organization"] != '' && element["ner_organization"] != null) {
                  organisasi.push(element["ner_organization"]);
                  organisasi2.push(element["ner_organization"]);
                }
              });
              const SetttOrganization = []
              const SetttOrganization2 = []
              for (let i = 0; i < organisasi.length; i++) {
                SetttOrganization.push(organisasi[i].at(-0))
                SetttOrganization2.push(organisasi2[i].at(-1))
              }

              const Setorganization = [...new Set(SetttOrganization)]
              const Setorganization2 = [...new Set(SetttOrganization2)]
              const Setorganization3 = Setorganization.concat(Setorganization2)

              this.SetOrganization = [...new Set(Setorganization3)]

              this.chart_data_sortOrganisasi = []
              for (let x = 0; x < this.SetOrganization.length; x++) {
                var jum1org = 0;
                for (let i = 0; i < this.MediaYtShare.length; i++) {
                  if (this.MediaYtShare[i].ner_organization != null) { //tambahan karna data ada yang null
                    if (this.MediaYtShare[i].ner_organization[0] != '' && this.MediaYtShare[i].ner_organization[0] != null) { //tambahan karna data ada yang null
                      if (this.MediaYtShare[i].ner_organization[0] == this.SetOrganization[x]) {
                        jum1org++;
                      }
                    }
                    if (this.MediaYtShare[i].ner_organization[1] != '' && this.MediaYtShare[i].ner_organization[1] != null) { //tambahan karna data ada yang null
                      if (this.MediaYtShare[i].ner_organization[1] == this.SetOrganization[x]) {
                        jum1org++;
                      }
                    }
                  }
                }

                this.chart_data_sortOrganisasi.push({
                  'name_organisasi' : this.SetOrganization[x],
                  'name_organisasi_value' : jum1org
                })
              }
              this.chart_data_sortOrganisasi.sort(function(a,b) { // sort desc value
                return (b.name_organisasi_value) - (a.name_organisasi_value);
              });
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                this.barchart.xaxis.categories[i] = ""
              }
              for (let i = 0; i < this.series1[0].data.length; i++) {
                this.series1[0].data[i] = ""
              }
              for (let x = 0; x < this.chart_data_sortOrganisasi.length; x++) {
                if (x < 6) {
                  this.series1[0].data[x] = this.chart_data_sortOrganisasi[x].name_organisasi_value
                  this.barchart.xaxis.categories[x] = this.chart_data_sortOrganisasi[x].name_organisasi
                }
              }
              for (let i = 0; i < this.barchart.xaxis.categories.length; i++) {
                if (this.barchart.xaxis.categories[i] == undefined) {
                  this.barchart.xaxis.categories[i] = ""
                }
              }
            }
            this.kontenBeritaNetral = this.kontenYoutubeNetral
            this.kontenBeritaNegative = this.kontenYoutubeNegative
            this.kontenBeritaPositive = this.kontenYoutubePositive
            const beritaNetralPersen = this.kontenYoutubeNetral.length / this.MediaYtShare.length * 100
            this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
            const beritaNegativePersen = this.kontenYoutubeNegative.length / this.MediaYtShare.length * 100
            this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
            const beritaPositvePersen = this.kontenYoutubePositive.length / this.MediaYtShare.length * 100
            this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
            this.kontenBerita = this.MediaYtShare
            this.pagelength = Math.ceil(this.kontenBerita.length / 100)
          }
        } catch (e) {
          console.log('error')
        }
      }
    },
    // ================================================================
    // ========================= and action click =====================
    // ================================================================

    clickChartBar(event, chartContext,config) {
      console.log(config.dataPointIndex)
      console.log(this.barchart.xaxis.categories[config.dataPointIndex])
      this.isClickBuble = this.barchart.xaxis.categories[config.dataPointIndex]

      if (this.isPerson == true) {
        this.$store.commit('addButtonTmp', {
          sentiment_glob:this.$store.sentiment_glob,
          ner_person_glob:this.barchart.xaxis.categories[config.dataPointIndex],
          ner_organization_glob:this.$store.ner_organization_glob
        })
      }

      if (this.isOrganisasi == true) {
        this.$store.commit('addButtonTmp', {
          sentiment_glob:this.$store.sentiment_glob,
          ner_person_glob:this.$store.ner_person_glob,
          ner_organization_glob:this.barchart.xaxis.categories[config.dataPointIndex]
        })
      }

      this.loadKontenBerita2()
    },
    generateData(baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
        var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
        var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;
        series.push([x, y, z]);
        baseval += 86400000;
        i++;
      }
      return series;
    }
    // function ??
    // clickTopPerson(name){
    //   this.dialog = true
    //     setTimeout(() => {
    //   this.dialog = false;
    //   }, 1000);     
    //   try{          
    //    if(name == this.SetPerson[0]){
    //     this.click = name
    //     this.chart[0].color = "#f20053"        
    //     this.chart[1].color = "#F1E987"
    //     this.chart[2].color = "#B3B8F4"
    //     this.chart[3].color = "#5EC3C2"
    //     this.chart[4].color = "#AFDAF5"
    //     this.chart[5].color = "#C4C4C4"
    //     this.chart[0].stroke= '#000'        
    //     this.chart[1].stroke= ''        
    //     this.chart[2].stroke= ''        
    //     this.chart[3].stroke= ''        
    //     this.chart[4].stroke= ''        
    //     this.chart[5].stroke= ''                  
    //     this.words = [[this.SetWord[0], this.wordCloudIndx0Person0.length], [this.SetWord[1], this.wordCloudIndx1Person0.length], [this.SetWord[2], this.wordCloudIndx2Person0.length], [this.SetWord[3], this.wordCloudIndx3Person0.length], [this.SetWord[4], this.wordCloudIndx4Person0.length]]                
    //     window.dispatchEvent(new Event('resize'))         
    //     if(this.isPerson == true){
    //     this.barchart.xaxis.categories[0] = this.SetPerson[0]
    //     this.barchart.xaxis.categories[1] = this.SetPerson[1]
    //     this.barchart.xaxis.categories[2] = this.SetPerson[2]
    //     this.barchart.xaxis.categories[3] = this.SetPerson[3]
    //     this.barchart.xaxis.categories[4] = this.SetPerson[4]
    //     this.barchart.xaxis.categories[5] = this.SetPerson[5]
    //     this.series1[0].data = [this.valueBublePerson0Indx0.length, this.valueBublePerson0Indx1.length, this.valueBublePerson0Indx2.length, this.valueBublePerson0Indx3.length, this.valueBublePerson0Indx4.length, this.valueBublePerson0Indx5.length]                    
    //     }    
    //     if(this.isOrganisasi == true){
    //       console.log('organisasi')
    //       this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
    //       this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
    //       this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
    //       this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
    //       this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
    //       this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
    //       this.series1[0].data = [this.valueBubleOrg0Indx0.length, this.valueBubleOrg0Indx1.length, this.valueBubleOrg0Indx2.length, this.valueBubleOrg0Indx3.length, this.valueBubleOrg0Indx4.length, this.valueBubleOrg0Indx5.length]                   
    //     }
    //       this.kontenBeritaPositive =  this.valueBublePerson0Positive
    //       this.kontenBeritaNegative = this.valueBublePerson0Negative
    //       this.kontenBeritaNetral = this.valueBublePerson0Netral
    //       const beritaNetralPersen = this.valueBublePerson0Netral.length / this.chartBubleIndx0.length * 100 
    //       this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
    //       const beritaNegativePersen = this.valueBublePerson0Negative.length / this.chartBubleIndx0.length * 100 
    //       this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
    //       const beritaPositvePersen = this.valueBublePerson0Positive.length / this.chartBubleIndx0.length * 100 
    //       this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
    //    }
    //    if(name == this.SetPerson[1]){
    //     this.click = name
    //     this.chart[0].color = "#F88FB3"      
    //     this.chart[1].color = "#ffe600"
    //     this.chart[2].color = "#B3B8F4"
    //     this.chart[3].color = "#5EC3C2"
    //     this.chart[4].color = "#AFDAF5"
    //     this.chart[5].color = "#C4C4C4"
    //     this.chart[0].stroke= ''        
    //     this.chart[1].stroke= '#000'        
    //     this.chart[2].stroke= ''        
    //     this.chart[3].stroke= ''        
    //     this.chart[4].stroke= ''        
    //     this.chart[5].stroke= ''         
    //     this.words = [[this.SetWord[0], this.wordCloudIndx0Person1.length], [this.SetWord[1], this.wordCloudIndx1Person1.length], [this.SetWord[2], this.wordCloudIndx2Person1.length], [this.SetWord[3], this.wordCloudIndx3Person1.length], [this.SetWord[4], this.wordCloudIndx4Person1.length]]                 
    //     window.dispatchEvent(new Event('resize'))         
    //     if(this.isPerson == true){
    //       this.barchart.xaxis.categories[0] = this.SetPerson[0]
    //       this.barchart.xaxis.categories[1] = this.SetPerson[1]
    //       this.barchart.xaxis.categories[2] = this.SetPerson[2]
    //       this.barchart.xaxis.categories[3] = this.SetPerson[3]
    //       this.barchart.xaxis.categories[4] = this.SetPerson[4]
    //       this.barchart.xaxis.categories[5] = this.SetPerson[5]
    //       this.series1[0].data = [this.valueBublePerson1Indx0.length, this.valueBublePerson1Indx1.length, this.valueBublePerson1Indx2.length, this.valueBublePerson1Indx3.length, this.valueBublePerson1Indx4.length, this.valueBublePerson1Indx5.length]                    
    //     }    
    //     if(this.isOrganisasi == true){
    //       console.log('organisasi')
    //       this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
    //       this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
    //       this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
    //       this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
    //       this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
    //       this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
    //       this.series1[0].data = [this.valueBubleOrg1Indx0.length, this.valueBubleOrg1Indx1.length, this.valueBubleOrg1Indx2.length, this.valueBubleOrg1Indx3.length, this.valueBubleOrg1Indx4.length, this.valueBubleOrg1Indx5.length]                   
    //     }
    //     this.kontenBeritaPositive =  this.valueBublePerson1Positive
    //     this.kontenBeritaNegative = this.valueBublePerson1Negative
    //     this.kontenBeritaNetral = this.valueBublePerson1Netral
    //     const beritaNetralPersen = this.valueBublePerson1Netral.length / this.chartBubleIndx1.length * 100 
    //     this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
    //     const beritaNegativePersen = this.valueBublePerson1Negative.length / this.chartBubleIndx1.length * 100 
    //     this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
    //     const beritaPositvePersen = this.valueBublePerson1Positive.length / this.chartBubleIndx1.length * 100 
    //     this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
    //    }
    //    if(name == this.SetPerson[2]){
    //     this.click = name
    //     this.chart[0].color = "#F88FB3"
    //     this.chart[1].color = "#F1E987"
    //      this.chart[2].color = "#0022ff"
    //      this.chart[3].color = "#5EC3C2"
    //      this.chart[4].color = "#AFDAF5"
    //      this.chart[5].color = "#C4C4C4"
    //       this.chart[0].stroke= ''        
    //       this.chart[1].stroke= ''        
    //       this.chart[2].stroke= '#000'        
    //       this.chart[3].stroke= ''        
    //       this.chart[4].stroke= ''        
    //       this.chart[5].stroke= ''             
    //       this.words = [[this.SetWord[0], this.wordCloudIndx0Person2.length], [this.SetWord[1], this.wordCloudIndx1Person2.length], [this.SetWord[2], this.wordCloudIndx2Person2.length], [this.SetWord[3], this.wordCloudIndx3Person2.length], [this.SetWord[4], this.wordCloudIndx4Person2.length]]                 
    //       window.dispatchEvent(new Event('resize'))         
    //   if(this.isPerson == true){
    //   this.barchart.xaxis.categories[0] = this.SetPerson[0]
    //   this.barchart.xaxis.categories[1] = this.SetPerson[1]
    //   this.barchart.xaxis.categories[2] = this.SetPerson[2]
    //   this.barchart.xaxis.categories[3] = this.SetPerson[3]
    //   this.barchart.xaxis.categories[4] = this.SetPerson[4]
    //   this.barchart.xaxis.categories[5] = this.SetPerson[5]
    //   this.series1[0].data = [this.valueBublePerson2Indx0.length, this.valueBublePerson2Indx1.length, this.valueBublePerson2Indx2.length, this.valueBublePerson2Indx3.length, this.valueBublePerson2Indx4.length, this.valueBublePerson2Indx5.length]                    
    //   }    
    //   if(this.isOrganisasi == true){
    //     this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
    //     this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
    //     this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
    //     this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
    //     this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
    //     this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
    //     this.series1[0].data = [this.valueBubleOrg2Indx0.length, this.valueBubleOrg2Indx1.length, this.valueBubleOrg2Indx2.length, this.valueBubleOrg2Indx3.length, this.valueBubleOrg2Indx4.length, this.valueBubleOrg2Indx5.length]                   
    //   }
    //    this.kontenBeritaPositive =  this.valueBublePerson2Positive
    //     this.kontenBeritaNegative = this.valueBublePerson2Negative
    //     this.kontenBeritaNetral = this.valueBublePerson2Netral
    //     const beritaNetralPersen = this.valueBublePerson2Netral.length / this.chartBubleIndx2.length * 100 
    //     this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
    //     const beritaNegativePersen = this.valueBublePerson2Negative.length / this.chartBubleIndx2.length * 100 
    //     this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
    //     const beritaPositvePersen = this.valueBublePerson2Positive.length / this.chartBubleIndx2.length * 100 
    //     this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
    //    }
    //    if(name == this.SetPerson[3]){
    //     this.click = name
    //     this.chart[0].color = "#F88FB3"
    //     this.chart[1].color = "#F1E987"
    //      this.chart[2].color = "#B3B8F4"
    //      this.chart[3].color = "#00fffc"
    //      this.chart[4].color = "#AFDAF5"
    //      this.chart[5].color = "#C4C4C4"
    //       this.chart[0].stroke= ''        
    //       this.chart[1].stroke= ''        
    //       this.chart[2].stroke= ''        
    //       this.chart[3].stroke= '#000'        
    //       this.chart[4].stroke= ''        
    //       this.chart[5].stroke= ''        
    //       this.words = [[this.SetWord[0], this.wordCloudIndx0Person3.length], [this.SetWord[1], this.wordCloudIndx1Person3.length], [this.SetWord[2], this.wordCloudIndx2Person3.length], [this.SetWord[3], this.wordCloudIndx3Person3.length], [this.SetWord[4], this.wordCloudIndx4Person3.length]]                 
    //       window.dispatchEvent(new Event('resize'))         
    //   if(this.isPerson == true){
    //   this.barchart.xaxis.categories[0] = this.SetPerson[0]
    //   this.barchart.xaxis.categories[1] = this.SetPerson[1]
    //   this.barchart.xaxis.categories[2] = this.SetPerson[2]
    //   this.barchart.xaxis.categories[3] = this.SetPerson[3]
    //   this.barchart.xaxis.categories[4] = this.SetPerson[4]
    //   this.barchart.xaxis.categories[5] = this.SetPerson[5]
    //   this.series1[0].data = [this.valueBublePerson3Indx0.length, this.valueBublePerson3Indx1.length, this.valueBublePerson3Indx2.length, this.valueBublePerson3Indx3.length, this.valueBublePerson3Indx4.length, this.valueBublePerson3Indx5.length]                    
    //   }    
    //   if(this.isOrganisasi == true){
    //     this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
    //     this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
    //     this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
    //     this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
    //     this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
    //     this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
    //     this.series1[0].data = [this.valueBubleOrg3Indx0.length, this.valueBubleOrg3Indx1.length, this.valueBubleOrg3Indx2.length, this.valueBubleOrg3Indx3.length, this.valueBubleOrg3Indx4.length, this.valueBubleOrg3Indx5.length]                   
    //   }
    //    this.kontenBeritaPositive =  this.valueBublePerson3Positive
    //     this.kontenBeritaNegative = this.valueBublePerson3Negative
    //     this.kontenBeritaNetral = this.valueBublePerson3Netral
    //     const beritaNetralPersen = this.valueBublePerson3Netral.length / this.chartBubleIndx3.length * 100 
    //     this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
    //     const beritaNegativePersen = this.valueBublePerson3Negative.length / this.chartBubleIndx3.length * 100 
    //     this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
    //     const beritaPositvePersen = this.valueBublePerson3Positive.length / this.chartBubleIndx3.length * 100 
    //     this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
    //    }
    //    if(name == this.SetPerson[4]){
    //     this.click = name
    //     this.chart[0].color = "#F88FB3"
    //     this.chart[1].color = "#F1E987"
    //      this.chart[2].color = "#B3B8F4"
    //      this.chart[3].color = "#5EC3C2"
    //      this.chart[4].color = "#009dff"
    //      this.chart[5].color = "#C4C4C4"
    //       this.chart[0].stroke= ''        
    //       this.chart[1].stroke= ''        
    //       this.chart[2].stroke= ''        
    //       this.chart[3].stroke= ''        
    //       this.chart[4].stroke= '#000'        
    //       this.chart[5].stroke= ''        
    //       this.words = [[this.SetWord[0], this.wordCloudIndx0Person4.length], [this.SetWord[1], this.wordCloudIndx1Person4.length], [this.SetWord[2], this.wordCloudIndx2Person4.length], [this.SetWord[3], this.wordCloudIndx3Person4.length], [this.SetWord[4], this.wordCloudIndx4Person4.length]]                 
    //       window.dispatchEvent(new Event('resize'))         
    //   if(this.isPerson == true){
    //   this.barchart.xaxis.categories[0] = this.SetPerson[0]
    //   this.barchart.xaxis.categories[1] = this.SetPerson[1]
    //   this.barchart.xaxis.categories[2] = this.SetPerson[2]
    //   this.barchart.xaxis.categories[3] = this.SetPerson[3]
    //   this.barchart.xaxis.categories[4] = this.SetPerson[4]
    //   this.barchart.xaxis.categories[5] = this.SetPerson[5]
    //   this.series1[0].data = [this.valueBublePerson4Indx0.length, this.valueBublePerson4Indx1.length, this.valueBublePerson4Indx2.length, this.valueBublePerson4Indx3.length, this.valueBublePerson4Indx4.length, this.valueBublePerson4Indx5.length]                    
    //   }    
    //   if(this.isOrganisasi == true){
    //     this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
    //     this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
    //     this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
    //     this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
    //     this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
    //     this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
    //     this.series1[0].data = [this.valueBubleOrg4Indx0.length, this.valueBubleOrg4Indx1.length, this.valueBubleOrg4Indx2.length, this.valueBubleOrg4Indx3.length, this.valueBubleOrg4Indx4.length, this.valueBubleOrg4Indx5.length]                   
    //   }
    //    this.kontenBeritaPositive =  this.valueBublePerson4Positive
    //     this.kontenBeritaNegative = this.valueBublePerson4Negative
    //     this.kontenBeritaNetral = this.valueBublePerson4Netral
    //     const beritaNetralPersen = this.valueBublePerson4Netral.length / this.chartBubleIndx4.length * 100 
    //     this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
    //     const beritaNegativePersen = this.valueBublePerson4Negative.length / this.chartBubleIndx4.length * 100 
    //     this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
    //     const beritaPositvePersen = this.valueBublePerson4Positive.length / this.chartBubleIndx4.length * 100 
    //     this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
    //    }
    //    if(name == this.SetPerson[5]){
    //     this.click = name
    //     this.chart[0].color = "#F88FB3"
    //      this.chart[1].color = "#F1E987"
    //      this.chart[2].color = "#B3B8F4"
    //      this.chart[3].color = "#5EC3C2"
    //      this.chart[4].color = "#AFDAF5"
    //      this.chart[5].color = "#454545"
    //       this.chart[0].stroke= ''        
    //       this.chart[1].stroke= ''        
    //       this.chart[2].stroke= ''        
    //       this.chart[3].stroke= ''        
    //       this.chart[4].stroke= ''        
    //       this.chart[5].stroke= '#000'        
    //       this.words = [[this.SetWord[0], this.wordCloudIndx0Person5.length], [this.SetWord[1], this.wordCloudIndx1Person5.length], [this.SetWord[2], this.wordCloudIndx2Person5.length], [this.SetWord[3], this.wordCloudIndx3Person5.length], [this.SetWord[4], this.wordCloudIndx4Person5.length]]                 
    //       window.dispatchEvent(new Event('resize'))         
    //   if(this.isPerson == true){
    //   this.barchart.xaxis.categories[0] = this.SetPerson[0]
    //   this.barchart.xaxis.categories[1] = this.SetPerson[1]
    //   this.barchart.xaxis.categories[2] = this.SetPerson[2]
    //   this.barchart.xaxis.categories[3] = this.SetPerson[3]
    //   this.barchart.xaxis.categories[4] = this.SetPerson[4]
    //   this.barchart.xaxis.categories[5] = this.SetPerson[5]
    //   this.series1[0].data = [this.valueBublePerson5Indx0.length, this.valueBublePerson5Indx1.length, this.valueBublePerson5Indx2.length, this.valueBublePerson5Indx3.length, this.valueBublePerson5Indx4.length, this.valueBublePerson5Indx5.length]                    
    //   }    
    //   if(this.isOrganisasi == true){
    //     this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
    //     this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
    //     this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
    //     this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
    //     this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
    //     this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
    //     this.series1[0].data = [this.valueBubleOrg5Indx0.length, this.valueBubleOrg5Indx1.length, this.valueBubleOrg5Indx2.length, this.valueBubleOrg5Indx3.length, this.valueBubleOrg5Indx4.length, this.valueBubleOrg5Indx5.length]                   
    //   }
    //    this.kontenBeritaPositive =  this.valueBublePerson5Positive
    //     this.kontenBeritaNegative = this.valueBublePerson5Negative
    //     this.kontenBeritaNetral = this.valueBublePerson5Netral
    //     const beritaNetralPersen = this.valueBublePerson5Netral.length / this.chartBubleIndx5.length * 100 
    //     this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
    //     const beritaNegativePersen = this.valueBublePerson5Negative.length / this.chartBubleIndx5.length * 100 
    //     this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
    //     const beritaPositvePersen = this.valueBublePerson5Positive.length / this.chartBubleIndx5.length * 100 
    //     this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
    //    }
    //   }      
    //   catch(e){
    //     console.log("error")
    //     console.log(e)
    //   }
    // },            
    // async loadSentimentanalysisBeritaOrganisasi(){
    //   this.dialog = true
    //   setTimeout(() => {
    //     this.dialog = false;
    //   }, 1000); 
    //   this.click = 'organisasi'
    //   if(this.click == 'organisasi'){       
    //     if(this.isOrganisasi == true){
    //       this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
    //       this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
    //       this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
    //       this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
    //       this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
    //       this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
    //       this.series1[0].data = [this.chartBubleIndx0Org.length, this.chartBubleIndx1Org.length, this.chartBubleIndx2Org.length, this.chartBubleIndx3Org.length,this.chartBubleIndx4Org.length, this.chartBubleIndx5Org.length]
    //     }
    //     this.seriess = []    
    //     this.seriess.push(this.kontenBeritaNetral.length, this.kontenBeritaNegative.length, this.kontenBeritaPositive.length)          
    //     window.dispatchEvent(new Event('resize'))       
    //   }
    // },
    // async loadSentimentanalysisBeritaPerson(){
    //   this.dialog = true
    //   setTimeout(() => {
    //     this.dialog = false;
    //   }, 1000); 
    //   this.click = ''
    //   if(this.click == ''){       
    //     if(this.isPerson == true){
    //       this.barchart.xaxis.categories[0] = this.SetPerson[0]
    //       this.barchart.xaxis.categories[1] = this.SetPerson[1]
    //       this.barchart.xaxis.categories[2] = this.SetPerson[2]
    //       this.barchart.xaxis.categories[3] = this.SetPerson[3]
    //       this.barchart.xaxis.categories[4] = this.SetPerson[4]
    //       this.barchart.xaxis.categories[5] = this.SetPerson[5]
    //       this.series1[0].data = [this.chartBubleIndx0.length, this.chartBubleIndx1.length, this.chartBubleIndx2.length, this.chartBubleIndx3.length, this.chartBubleIndx4.length, this.chartBubleIndx5.length]
    //     }          
    //     this.seriess = []    
    //     this.seriess.push(this.kontenBeritaNetral.length, this.kontenBeritaNegative.length, this.kontenBeritaPositive.length)             
    //     window.dispatchEvent(new Event('resize'))      
    //   }
    // },
  }
}
</script>

<style>
/*05/01 tambahkan style tab*/
.tab{
  font-size: 12px;
}
/*note css jangan diubah*/
.v-sheet--offset {
  top: -24px;
  position: relative;
}
#app{
  background-color: #f7f6f4;
}
.apexcharts-toolbar {
  z-index: 0;
}
.tooltip .tooltip-inner{
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 9px !important;
  max-width: 100px;
}
.row-pointer{
  cursor: pointer;
}
.overflow-card {
  overflow-y: scroll;
  overflow-x: hidden;
}
::-webkit-scrollbar{width:9px; }
::-webkit-scrollbar-thumb{width:9px; border-left:1px; background-color:#c4c4c4; border-radius: 100px;}
svg {
  display: block;
  margin: 0 auto;
}
.chart {
  transition: transform 0.7s ease-in-out;
  text-anchor: middle;
  cursor: pointer;
}
.chart__circle {
  transition: r .3s ease-in-out;
}
.chart__label {
  font-size: 14px;
  fill: #fff;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
</style>